import { JobsService } from "src/app/core/services/jobs.service";
import { NgxSpinner, NgxSpinnerService } from "ngx-spinner";
import {
  Component,
  OnInit,
  AfterViewChecked,
  ElementRef,
  ViewChild,
  OnDestroy,
  HostListener,
} from "@angular/core";
import {
  Observable,
  interval,
  Subscription,
  Subject,
  filter,
  takeUntil,
  lastValueFrom,
  take,
  skip,
  map,
  tap,
  debounceTime,
  switchMap,
  catchError,
  takeWhile,
  of,
  forkJoin,
  distinctUntilChanged,
} from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { StorageDataTransferService } from "../../../../core/services/storage-data-transfer.service";
import { StorageService } from "../../../../core/services/storage.service";
import { NavigationService } from "../../../../core/services/navigation.service";
import {
  StorageDataLevel,
  StorageDataType,
} from "../../../../core/models/storage-data-type";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { FileSizePipe } from "src/app/core/pipes/file-size.pipe";
import { NodeService } from "src/app/core/services/node.service";
import {
  AzureStorageType,
  CopyPasteObj,
  FileTab,
  StorageLogs,
} from "src/app/core/models/storage";
import { CreateDirectoryComponent } from "../../modals/create-directory/create-directory.component";
import { DeleteConfirmComponent } from "../../modals/delete-confirm/delete-confirm.component";
import { ManageStorageLogsService } from "src/app/core/services/manage-storage-logs.service";
import { ActionLogService } from "src/app/core/services/action-log.service";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import {
  CloudTypes,
  Entities,
  FileTypes,
  HpcJobStageNames,
  KeyValuePair,
  Store,
} from "src/app/core/models/globals";
import { FileItem, FileUploader } from "ng2-file-upload";
import { Node } from "src/app/core/models/node";
import { RenameComponent } from "../../modals/rename/rename.component";
import { FileEditorComponent } from "../../../job/modals/jobActions/file-editor/file-editor.component";
import { EnvironmentService } from "../../../../core/services/environment.service";
import { GoogleCloudService } from "../../../../core/services/google-cloud.service";
import { StorageOracleService } from "src/app/core/services/storage-oracle.service";
import { HttpClient, HttpEventType, HttpResponse } from "@angular/common/http";
import { HeaderService } from "../../../../core/services/header.service";
import { UserRoleNames, UserRolesInt } from "../../../../core/models/users";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { UtilityService } from "src/app/core/services/utility.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AwsCloudService } from "../../../../core/services/aws-cloud.service";
import { Clipboard } from "@angular/cdk/clipboard";
import { FileAlreadyExistsActionComponent } from "../../modals/file-already-exists-action/file-already-exists-action.component";
import { FormControl } from "@angular/forms";
import { MonacoFileEditorComponent } from "../../../job/modals/jobActions/monaco-file-editor/monaco-file-editor.component";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { DownloadResult, FileOperationContext, OperationResult, UploadContext, UploadProgress } from "src/app/core/models/storage-models.interface";
import { IStorageOperations } from "./storage-operations.interface";
import { StorageStrategyFactory } from "./storage-operation.factory";

enum StorageErrorTypes {
  "WorkDirectoryNotCreated" = "Working directory of the Job has not been created yet.",
  "PermissionDenied" = "You do not have permission to access this folder.",
  "DirectoryEmpty" = "Directory is empty.",
  "HpcWorkStoreOff" = "In order to access workstore please power on the cluster.",
  "VdiWorkStoreOff" = "Unable to load data. Please check if storage is configured for this deployment.",
  "UnknownError" = "Unable to load data.",
  "PathNotFound" = "Working directory path not found.",
}

enum UploadProcess {
  "Uploading" = "Uploading",
  "Updating" = "Updating",
  "Creating" = "Creating",
}

@Component({
  selector: "app-storage-data-transfer",
  templateUrl: "./storage-data-transfer.component.html",
  styleUrls: ["./storage-data-transfer.component.scss"],
  providers: [
    { provide: "fileSasUrl", useValue: "container" },
    { provide: "shareName", useValue: "container" },
  ],
})
export class StorageDataTransferComponent
  implements OnInit, AfterViewChecked, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private storageService: StorageService,
    private headerService: HeaderService,
    private authenticationService: AuthenticationService,
    public storageDataTransferService: StorageDataTransferService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private navService: NavigationService,
    private jobService: JobsService,
    private nodeService: NodeService,
    private fileSize: FileSizePipe,
    private snackBar: MatSnackBar,
    private storageLogService: ManageStorageLogsService,
    private actionLogService: ActionLogService,
    private syncConfig: SyncConfigService,
    private env: EnvironmentService,
    private googleCloudService: GoogleCloudService,
    private _oracleService: StorageOracleService,
    private awsService: AwsCloudService,
    private deploymentService: DeploymentService,
    private utilityService: UtilityService,
    private modalService: NgbModal,
    private clipboard: Clipboard,
    private _http: HttpClient,
    private storageFactory: StorageStrategyFactory
  ) {
    this.route.queryParams
      .pipe(
        map(async (x) => {
          if (x?.fileShare) {
            const storageConfig: any = await lastValueFrom(
              this.storageService
                .getStorageData(x.fileShare)
                .pipe(takeUntil(this.destroy$))
            );
            if (storageConfig?.type == "fileStore") {
              this.syncStorePath = storageConfig.mountDirectory;
              this.uploader.options.headers[0].value = `${this.syncStorePath}/${this.currentLoggedInUser}`;
              this.userRootSyncStorePath = `${this.syncStorePath}/${this.currentLoggedInUser}`;
              this.cloudType = CloudTypes.OnPremise;
              this.stores = ["SyncStore"];
              this.isFileStore = true;
              this.storageService.sendJobStorageDirectoryPath(
                this.userRootSyncStorePath
              );
            }
          }
          return x;
        })
      )
      .subscribe();
  }

  @ViewChild("basicMenu") public basicMenu: any;
  @ViewChild("inputMultiFiles") inputMultiFiles: ElementRef;
  @ViewChild("inputFolder") inputFolder: ElementRef;
  @ViewChild("scrollMe") private myScrollContainer: ElementRef;

  private storageStrategy: IStorageOperations;

  syncStorePath: string = this.env.envVariables.syncStoreRoute;
  workStorePath: string = this.env.envVariables.workStoreRoute;
  clickedArray = [];
  defaultPath: string;
  dirName: string;
  syncStoreCrumbs: StorageDataLevel[] = [];
  syncStoreItems: StorageDataType[];
  selectedIndex: number;
  selectedFiles: FileList;
  progressInfos = [];
  fileInfos: Observable<any>;
  depName: string =
    this.route.parent.parent.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"];
  currentEntity: string;
  accountName: string;
  toShow: boolean = true;
  tempActiveProperty: string;
  activeStore: string = Store.SyncStore;
  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "bottom";
  breadArr = [];
  deleteFileData = [];
  disableScrollDown = false;
  multiSelectIndex = [];
  selectAll: boolean;
  userNotAuthorized: boolean = false;
  dirPathSub: Subscription;
  storeDataReload: Subscription;
  cancelUploadSub: Subscription;
  listFilesSub: Subscription;
  deleteFilesSub: Subscription;
  createDirSub: Subscription;
  autoScroll: boolean;
  jobNodeName: string;
  jobNodeSub: Subscription;
  leftPanelIndex: any;
  counterErrorCount: number = 0;
  errorMsg: StorageErrorTypes = null;
  nodes: Node[];
  isWorkStoreActive: boolean = false;
  workStoreNodeChoosen: string = "All";
  itemCopied: boolean = false;
  copiedFilePath: string; //contains path of the file choosed for copy
  destinationPath: string;
  lastClickedIdx: number;
  cloudType: CloudTypes =
    this.route.parent.parent.snapshot.params["cloudType"] ||
    this.route.parent.snapshot.params["cloudType"] ||
    this.route.parent.snapshot.params.cloudName;
  sourcePath = [];
  currentStorageName: string =
    this.headerService?.getStorageNameForDeployment(this.depName) ||
    this.route.parent.parent.snapshot.params["storageName"] ||
    this.route.parent.snapshot.params["storageName"];
  currentLoggedInUser =
    this.authenticationService.currentUserValue.username?.split("@")[0];
  storageSearch: string = "";
  StorageLogsData: StorageLogs[] = [];
  checkStorageLogService: Subscription;
  uniqueLogId: number = 0; // contains index of the log - used for finding the log
  currentFullPathAzure: string;
  fileUploadHeadNodeIP: string = null;
  fileDownloadHeadNodeIP: string = null;
  sizeSort: boolean = false; // filter
  lastModifiedSort: boolean = false; // filter
  fileNameSort: boolean = false; // filter
  ownerSort: boolean = false; // filter
  activeSort: string = "none"; // for checking if any sort is active while, used when auto refreshing data
  filtersApplied: boolean = false; // filter
  fileUploadHeadNodePORT: string = this.env.envVariables.BMFileUploadPORT;
  fileUploadURL: string = `${this.env.envVariables.httpProtocol}${this.fileUploadHeadNodeIP}:${this.fileUploadHeadNodePORT}/upload`;
  uploader: FileUploader = new FileUploader({
    url: this.fileUploadURL,
    headers: [
      {
        name: "destinationpath",
        value: `${this.syncStorePath}/${this.currentLoggedInUser}`,
      },
      { name: "requestUser", value: this.currentLoggedInUser },
      { name: "islocalstore", value: "false" },
      { name: "vmname", value: "null" },
      { name: "isfolder", value: "false" },
    ],
    method: "post",
    removeAfterUpload: true,
  });
  selectedVmName: string;
  clickedForRename: string;
  deactivateRefresh: boolean = false;
  isVDIDep: boolean = false;
  toCancelUploadFiles = {};
  currentLoggedInUserRole: number;
  renameSupportedCloudTypes: CloudTypes[] = [
    CloudTypes.OnPremise,
    CloudTypes.Oracle,
    CloudTypes.Google,
  ];
  isBreadCrumbEditable: boolean = false;

  userRootSyncStorePath: string =
    this.syncStorePath + "/" + this.currentLoggedInUser;
  userRootWorkStorePath: string =
    this.env.envVariables.workStoreRoute + "/" + this.currentLoggedInUser;

  showDownloadBtn: boolean = false;
  toShowUploadBtn: boolean = false;
  isMonitor: boolean =
    this.authenticationService.currentUserValue.role == UserRoleNames.Reader
      ? true
      : false;
  isDraggedOver: any = 0;
  isSpinnerActive: boolean = true;
  routeViaSynchpc: boolean =
    this.deploymentService.getProfileInfoFromSubject(this.depName)
      ?.routeViaSynchpc || false;

  toShowLogs: boolean = false;
  toBlink: boolean = false;
  stores = ["SyncStore", "WorkStore"];

  storageControl = new FormControl();
  showSelectableStorage: boolean = false;
  allStorages: KeyValuePair[] = [];
  isFileStore: boolean = false;
  destroy$ = new Subject<void>();

  tabsAvailable: FileTab[] = [];
  activeTabIndex: number = 0;

  filterSearch: FormControl = new FormControl("");
  filterItems;
  config = {
    itemsPerPage: 100,
    currentPage: 1,
  };
  fileUploadsQueue: Map<
    number,
    { uploader: FileUploader; fileName: string; isCancelled: boolean; serverFileName?: any }
  > = new Map();
  reg: string = this.env.envVariables.fileUploadRegex;
  regexObj: any = new RegExp(this.reg ? this.reg : "^[A-Za-z0-9-_.@]+$");
  disableButtonsForMutliselectRightClick = false;
  private recentlyCancelledFiles = new Set<string>();
  private readonly CANCEL_CLEANUP_DELAY = 3000;
  checkCurrentEntity: Subscription;
  jobOrStorageTypeChanged: boolean = false;
  private currentRequestId = 0;

  async ngOnInit() {
    this.spinner.show("storageLoad");
    if (this.cloudType == CloudTypes.Oracle) {
      let par = await this._oracleService.getPreAuthenticatedUri(
        this.depName,
        this.currentStorageName
      );
    }

    if (!this.currentStorageName || this.currentStorageName?.indexOf(",") != -1) {
      this.currentStorageName =
        this.route?.snapshot?.params?.storageName ||
        this.route.parent?.snapshot?.params?.storageName;
    }

    this.storageService
      .checkIsVdi(this.depName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.isVDIDep = data;
        },
      });
    this.currentLoggedInUserRole = this.headerService.getUserRoleForDeployment(
      this.depName
    );
    if (this.isAIStudioRoute()) {
      this.currentEntity = "AI Studio";
    } else {
      this.navService.breadcrumbEntity.subscribe((x) => {
        this.currentEntity = x;
      });
    }
    if (this.currentEntity == Entities.Storages || this.currentEntity == Entities.AIStudio) {
      this.navService.sendParentData(`Explorer (${this.currentStorageName})`);
    }
    this.navService.breadcrumbActiveProperty.subscribe(
      (name) => (this.tempActiveProperty = name)
    );
    if (this.currentEntity == Entities.Jobs) {
      this.jobService.syncstoreUsed$.subscribe((x) => {
        this.currentStorageName = x || this.currentStorageName;
      });
      //this.currentStorageName = this.storageService.getJobSyncstoreUsed() || this.currentStorageName;
      this.toShow = false;
    } else if (
      this.currentEntity == Entities.Deployments &&
      this.tempActiveProperty != Entities.Jobs
    ) {
      this.navService.sendParentData("Storage");
      this.navService.sendLeftPanelIndex(4);
      this.storageService.sendJobStorageDirectoryPath(
        this.userRootSyncStorePath
      );
      const storages = this.deploymentService.getStorageAccNameForDeployment(
        this.depName
      );
      if (storages?.length > 1) {
        this.allStorages = storages.map((x) => {
          return { key: x, value: x };
        });
        this.showSelectableStorage = true;
      }
      if (!this.currentStorageName && storages?.length > 0)
        this.currentStorageName = storages[0];
      this.storageControl.setValue(this.currentStorageName);
      this.storageControl.valueChanges.pipe().subscribe(async (x) => {
        this.stores = ["SyncStore", "WorkStore"];
        this.activeStore = Store.SyncStore;
        this.spinner.show("storageLoad");
        this.currentStorageName = x;
        if (this.cloudType == CloudTypes.MicrosoftAzure) {
          this.storageDataTransferService.serviceClient = null;
          this.getSasStorageShare();
        } else {
          const storageConfig: any = await lastValueFrom(
            this.storageService
              .getStorageData(this.currentStorageName)
              .pipe(takeUntil(this.destroy$))
          );
          if (storageConfig?.type == "fileStore") {
            this.syncStorePath = storageConfig.mountDirectory;
            this.uploader.options.headers[0].value = `${this.syncStorePath}/${this.currentLoggedInUser}`;
            this.userRootSyncStorePath = `${this.syncStorePath}/${this.currentLoggedInUser}`;
            this.cloudType = CloudTypes.OnPremise;
            this.isFileStore = true;
          } else {
            this.syncStorePath = this.env.envVariables.syncStoreRoute;
            this.userRootSyncStorePath =
              this.env.envVariables.syncStoreRoute +
              "/" +
              this.currentLoggedInUser;
          }
          if (storageConfig) {
            this.stores = ["SyncStore"];
          }
          this.storageService.sendJobStorageDirectoryPath(
            this.userRootSyncStorePath
          );
        }
      });
    } else if (this.currentEntity == Entities.Storages || this.currentEntity == Entities.AIStudio) {
      this.storageService.sendJobStorageDirectoryPath(
        this.userRootSyncStorePath
      );
      this.navService.sendLeftPanelIndex(0);
    } else {
      this.toShow = false;
    }
    if (this.syncStoreCrumbs) {
      this.syncStoreCrumbs = [];
    }

    this.navService.index.subscribe((x) => (this.leftPanelIndex = x));

    if (
      this.cloudType == CloudTypes.MicrosoftAzure &&
      !this.storageDataTransferService.serviceClient
    ) {
      this.getSasStorageShare();
    } else {
      this.maintainPathWorking();
    }
    this.nodeService.getNodesForDeployment(this.depName).subscribe((data) => {
      this.nodes = <Node[]>JSON.parse(JSON.stringify(data));
      if (this.nodes) {
        let idx = this.nodes.findIndex((n) => n.nodeType.includes("Head"));
        if (idx >= 0) {
          this.selectedVmName = this.nodes[idx].vmName;
          this.getVmIp(this.selectedVmName);
        }
      }
    });
    this.getStorageLogsdata();
    this.configureNg2FileUpload();
    this.configureDeploymentSpecificInfo();
    this.spinner.getSpinner("storageLoad").subscribe((x: NgxSpinner) => {
      this.isSpinnerActive = x.show;
    });
    this.tabsAvailable = this.storageService.getNonClosedFilesData(
      this.depName,
      this.currentEntity == Entities.Jobs ? Entities.Jobs : Entities.Storages
    );
    this.filterSearch.valueChanges
      .pipe(
        tap(() => {
          if (this.jobOrStorageTypeChanged) {
            this.jobOrStorageTypeChanged = false;
            this.applyFilter();
            return;
          }
        }),
        filter(() => !this.jobOrStorageTypeChanged), // Skip debounce job or strorage changed
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((searchValue) => {
        this.storageSearch = searchValue;
        this.applyFilter();
      });
  }
  private isAIStudioRoute(): boolean {
    const url = this._router.url;
    return url.includes('AI') && url.includes('Projects');
  }

  private applyFilter() {
    if (!this.syncStoreItems) {
      this.filterItems = [];
      return;
    }

    if (!this.storageSearch?.trim()) {
      this.filterItems = this.syncStoreItems;
    } else {
      const searchLower = this.storageSearch.toLowerCase();
      this.filterItems = this.syncStoreItems.filter(item => 
        item.name?.toLowerCase().includes(searchLower)
      );
      this.config.currentPage = 1;
    }
  }

  ngOnDestroy() {
    if (this.dirPathSub) {
      this.dirPathSub.unsubscribe();
    }
    if (this.storeDataReload) {
      this.storeDataReload.unsubscribe();
    }
    if (this.listFilesSub) this.listFilesSub.unsubscribe();
    this.breadArr = [];
    this.multiSelectIndex = [];
    this.deleteFileData = [];
    this.StorageLogsData = [];
    // this.uploader.cancelAll();
    this.storageLogService?.updateToShowAllStart();
    this.checkStorageLogService?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  configureDeploymentSpecificInfo() {
    this.headerService.QuickAccessDep.pipe(take(2)).subscribe((data) => {
      let depInfo = data.find((d) => d.name == this.depName);
      if (!this.currentStorageName) {
        this.currentStorageName = depInfo?.storageAccountName.split(",")[0];
        this.storageControl.setValue(this.currentStorageName);
      }
      this.uploader.options.headers[3].value = depInfo?.isLocalStore.toString();
    });
  }

  configureNg2FileUpload() {
    this.uploader.onProgressItem = (item: any) => {
      let uniqueId = this.storageLogService.findUniqueIdWithFileName(
        item.file.name
      );
      let ui_progress = `Uploaded ${item["progress"]}%`;
      this.storageLogService.updateStatusOfLog(uniqueId, ui_progress);
    };
    this.uploader.onErrorItem = (item: any) => {
      let uniqueId = this.storageLogService.findUniqueIdWithFileName(
        item.file.name
      );
      this.storageLogService.updateTimeRemaining(uniqueId, null);
      this.storageLogService.updateRequestCompleteFields(uniqueId, "Failed");
      this.uniqueLogId += 1;
      this.checkUtilityServiceRunning(item.file.name);
    };
    this.uploader.onSuccessItem = (item: any) => {
      let uniqueId = this.storageLogService.findUniqueIdWithFileName(
        item.file.name
      );
      this.storageLogService.updateTimeRemaining(uniqueId, null);
      this.storageLogService.updateRequestCompleteFields(uniqueId, "Completed");
      this.listFiles(this.defaultPath);
    };
  }

  async startNg2Upload(e, process: UploadProcess = UploadProcess.Uploading) {
    let overWriteAll: boolean = process === UploadProcess.Updating;
    
    if (this.activeStore === Store.SyncStore && this.cloudType !== CloudTypes.OnPremise) {
      this.uploadFiles(e, overWriteAll);
      return;
    }
    
    let abortAll: boolean = false;
    const files: File[] = Array.from(e);
    
    for (const file of files) {
      if (!file.name.match(this.regexObj)) {
        this.snackBar.open("File with special character and space cannot be uploaded.", "Ok", { duration: 3000 });
        continue;
      }

      let uploadPath = this.defaultPath;
      if (file.webkitRelativePath && file.webkitRelativePath !== "") {
        const relativeDirs = file.webkitRelativePath.split("/");
        relativeDirs.pop(); 
        if (relativeDirs.length > 0) {
          uploadPath = this.defaultPath + "/" + relativeDirs.join("/");
        }
      }
      
      if (!overWriteAll) {
        const fileExists = this.checkIfItemPathExists(file.name);
        if (fileExists) {
          if (abortAll) continue;
          
          const result = await lastValueFrom(
            this.dialog.open(FileAlreadyExistsActionComponent, {
              autoFocus: false,
              disableClose: true,
              width: "40vw",
              data: {
                title: "File/Folder already exists",
                message: `File/Folder with name ${file.name} at path ${this.defaultPath} already exists. Please choose an action to perform.`,
                showAllButtons: files.length !== 1,
              },
            }).afterClosed()
          );
          
          if (!result || result === 1) {
            if (result === 1) abortAll = true;
            continue;
          } else if (result === 3) {
            overWriteAll = true;
          }
        }
      }
      
      this.uniqueLogId += 1;
      const currentUniqueId = this.uniqueLogId;
      
      const logMsg = `${process} ${file.name} at path '${uploadPath}': `;
      
      const newLogObj: StorageLogs = this.storageLogService.createLogObject(
        currentUniqueId, this.depName, 1, file.name, uploadPath, logMsg, "Pending", true
      );
      this.addLogToStorageLogs(newLogObj);
      
      const context: FileOperationContext = {
        deploymentName: this.depName,
        nodeName: this.getActiveWorkstoreNodeName() || undefined,
        currentPath: uploadPath,
        cloudType: this.cloudType,
        activeStore: this.activeStore,
        currentStorageName: this.currentStorageName,
        userInfo: { 
          username: this.currentLoggedInUser, 
          role: this.currentLoggedInUserRole,
          headNodeIP: this.fileUploadHeadNodeIP
        }
      };
      
      const uploadContext: UploadContext = {
        overwriteExisting: overWriteAll,
        createDirectories: true
      };
      
      try {
        this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, uploadPath);
        
        this.storageStrategy.uploadFile(file, uploadPath, context, currentUniqueId, uploadContext)
          .subscribe({
            next: (progress: UploadProgress) => {
              if (progress.percentage < 100) {
                this.storageLogService.updateStatusOfLog(currentUniqueId, `Uploaded ${progress.percentage}%`);
                if (progress.timeRemaining) {
                  this.storageLogService.updateTimeRemaining(currentUniqueId, progress.timeRemaining);
                }
                this.storageLogService.updateStorageLogsStore();
              }
            },
            error: (error) => {
              console.error(`Upload failed for ${file.name}:`, error);
              this.storageLogService.updateTimeRemaining(currentUniqueId, null);
              this.storageLogService.updateRequestCompleteFields(currentUniqueId, "Failed");
              this.actionLogService.addActionLog(this.depName, "Upload", file.name, this.currentStorageName, "Storage", logMsg, 2, "Failed");
              
              if (error.message?.includes("special character")) {
              } else {
                this.checkUtilityServiceRunning(file.name);
              }
            },
            complete: () => {
              this.storageLogService.updateTimeRemaining(currentUniqueId, null);
              this.storageLogService.updateRequestCompleteFields(currentUniqueId, "Completed");
              
              this.actionLogService.addActionLog(this.depName, "Upload", file.name, this.currentStorageName, "Storage", logMsg, 2, "Successful");
              setTimeout(() => {
                this.listFiles(this.defaultPath);
              }, 500);
            }
          });
          
      } catch (error) {
        console.error(`Failed to start upload for ${file.name}:`, error);
        this.storageLogService.updateTimeRemaining(currentUniqueId, null);
        this.storageLogService.updateRequestCompleteFields(currentUniqueId, "Failed");
      }
    }
  }

  checkIfItemPathExistsInDirectory(fileName: string, targetPath: string): boolean {
    if (targetPath === this.defaultPath) {
      return this.checkIfItemPathExists(fileName);
    }
    
    return false;
  }
  
  async uploadFiles(event, isEditUpload: boolean = false) {
    if (!this.syncStoreItems) return;
    this.multiSelectIndex = [];
    this.selectAll = false;
    this.selectedFiles = event;
    
    const files = Array.from(event) as File[];
    
    for (const file of files) {
      if (!file.name.match(this.regexObj)) {
        this.snackBar.open("File with special character and space cannot be uploaded.", "Ok", { duration: 3000, });
        continue;
      }
      let dirName: string;
      if (file?.webkitRelativePath != "") {
        dirName =
          this.defaultPath +
          "/" +
          this.getWebkitDirPath(file.webkitRelativePath);
      }else{
        dirName = this.defaultPath;
      }

      if (!isEditUpload) {
        const fileExists = this.checkIfItemPathExists(file.name);
        if (fileExists) {
          const result = await lastValueFrom(
            this.dialog
              .open(FileAlreadyExistsActionComponent, {
                autoFocus: false,
                disableClose: true,
                width: "40vw",
                data: {
                  title: "File/Folder already exists",
                  message: `File/Folder with name ${file.name} at path ${dirName} already exists. Please choose an action to perform.`,
                  showAllButtons: false,
                },
              })
              .afterClosed()
          );
          
          if (!result || result == 1) {
            continue; 
          }
        }
      }

      this.uniqueLogId += 1;
      const currentUniqueId = this.uniqueLogId;

      let logMsg = `Uploading ${file.name} at path '${dirName}': `;

      let newLogObj: StorageLogs = this.storageLogService.createLogObject(currentUniqueId, this.depName, 1, file.name, dirName, logMsg, "Upload Pending", true);
      this.addLogToStorageLogs(newLogObj);

      const context: FileOperationContext = {
        deploymentName: this.depName,
        nodeName: this.getActiveWorkstoreNodeName() || undefined,
        currentPath: dirName,
        cloudType: this.cloudType,
        activeStore: this.activeStore,
        currentStorageName: this.currentStorageName,
        syncStorePath: this.syncStorePath,
        userInfo: { 
          username: this.currentLoggedInUser, 
          role: this.currentLoggedInUserRole,
          headNodeIP: this.fileUploadHeadNodeIP
        }
      };

      const uploadContext: UploadContext = {
        overwriteExisting: isEditUpload,
        createDirectories: true
      };

      try {
        this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, dirName);
        this.storageStrategy.uploadFile(file, dirName, context, currentUniqueId, uploadContext)
        .subscribe({
          next: (progress: UploadProgress) => {

          },
          error: (error) => {
            console.error(`Upload failed for ${file.name}:`, error);
            this.storageLogService.updateTimeRemaining(currentUniqueId, null);
            this.storageLogService.updateRequestCompleteFields(currentUniqueId, "Upload Failed");
            this.actionLogService.addActionLog(this.depName, "Upload", file.name, this.currentStorageName, "Storage", logMsg, 2, "Failed");

          },
          complete: () => {
            this.actionLogService.addActionLog(this.depName, "Upload", file.name, this.currentStorageName, "Storage", logMsg, 2, "Successful");
            
            setTimeout(() => {
              this.listFiles(this.defaultPath);
            }, 500);
          }
        });
      } catch (error) {
        console.error(`Failed to start upload for ${file.name}:`, error);
        this.storageLogService.updateTimeRemaining(currentUniqueId, null);
        this.storageLogService.updateRequestCompleteFields(currentUniqueId, "Upload Failed");
      }
    }

    this.inputMultiFiles.nativeElement.value = "";
  }

  async selectFolder() {
    if ('showDirectoryPicker' in window) {
      try {
        const directoryHandle = await (window as any).showDirectoryPicker();
        const files: File[] = [];
        
        await this.collectFiles(directoryHandle, directoryHandle.name, files);
        
        const fileList = this.createFileListFromArray(files);
        this.uploadFolderFiles(fileList);
        
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Error selecting folder:', error);
          this.inputFolder.nativeElement.click();
        }
      }
    } else {
      this.inputFolder.nativeElement.click();
    }
  }

  private async collectFiles(directoryHandle: any, path: string, files: File[]): Promise<void> {
    for await (const [name, handle] of directoryHandle) {
      const filePath = `${path}/${name}`; 
      
      if (handle.kind === 'file') {
        const file = await handle.getFile();
        Object.defineProperty(file, 'webkitRelativePath', {
          value: filePath,
          writable: false
        });
        files.push(file);
      } else if (handle.kind === 'directory') {
        await this.collectFiles(handle, filePath, files);
      }
    }
  }

  private createFileListFromArray(files: File[]): FileList {
    const fileList = {
      length: files.length,
      item: (index: number) => files[index] || null,
      *[Symbol.iterator]() {
        for (let i = 0; i < files.length; i++) {
          yield files[i];
        }
      }
    } as any;
    
    files.forEach((file, index) => {
      fileList[index] = file;
    });
    
    return fileList as FileList;
  }

  async uploadFolderFiles(files: FileList | null) {
    if(!files || files.length == 0){
      this.uniqueLogId += 1;
      const newLogObj: StorageLogs = this.storageLogService.createLogObject(this.uniqueLogId, this.depName, 1, "", 
        this.defaultPath, "Uploading folder : ", "", true);
      this.addLogToStorageLogs(newLogObj);
      this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed : No files selected or Empty folder selected.");
      return;
    }

    const directoryPaths = this.extractDirectoryPaths(files);

    if(directoryPaths.length === 0){
      this.uniqueLogId += 1;
      const newLogObj: StorageLogs = this.storageLogService.createLogObject(this.uniqueLogId, this.depName, 1, "", this.defaultPath, "Uploading folder : ", "", true);
      this.addLogToStorageLogs(newLogObj);
      this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed : No valid files with directory structure found.");
      return;
    }

    const context: FileOperationContext = {
      deploymentName: this.depName,
      nodeName: this.getActiveWorkstoreNodeName() || undefined,
      currentPath: this.defaultPath,
      cloudType: this.cloudType,
      activeStore: this.activeStore,
      currentStorageName: this.currentStorageName,
      syncStorePath: this.syncStorePath,
      userInfo: { 
        username: this.currentLoggedInUser, 
        role: this.currentLoggedInUserRole,
        headNodeIP: this.fileUploadHeadNodeIP
      }
    };

    this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath);
    try{
      await this.storageStrategy.verifyDirectoryPath(directoryPaths, context).toPromise();
    }catch(err){
      console.error("Directory verification or creation failed:", err);
      return;
    }

    this.uploadFiles(Array.from(files), true); // reason to send true is to avoid multiple file exists popups, because we are uploading directories
  }

  private extractDirectoryPaths(files: FileList): string[] {
    const paths = Array.from(files)
      .filter(file => file.webkitRelativePath && file.webkitRelativePath !== "")
      .map(file => {
        const pathParts = file.webkitRelativePath.split('/');
        pathParts.pop(); 
        return pathParts.join('/');
      })
      .filter(path => path !== ""); 

    const uniquePaths = [...new Set(paths)];
    const expandedPaths = new Set<string>();
    
    uniquePaths.forEach(path => {
      if (!path) return;
      const parts = path.split('/').filter(p => p.trim() !== '');
      
      for (let i = 1; i <= parts.length; i++) {
        const currentPath = parts.slice(0, i).join('/');
        if (currentPath) expandedPaths.add(currentPath);
      }
    });

    return Array.from(expandedPaths).sort((a, b) => a.length - b.length);
  }

  updateFileuploadUrl(vmIp: string) {
    this.fileUploadURL = this.fileUploadURL.replace("null", vmIp);
  }

  getOperationName(logType: number): string {
    const names = {
      1: 'Upload',
      2: 'Download', 
      3: 'Operation',
      4: 'Zip',
      5: 'Unzip'
    };
    return names[logType] || 'Operation';
  }

  getSasStorageShare() {
    this.storageService
      .getStorageSasShare(this.depName, this.currentStorageName || "default")
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (this.cloudType == CloudTypes.MicrosoftAzure) {
            this.storageDataTransferService
              .azureFilesInitialize(data?.sas, data?.share)
              .then((data) => {
                this.maintainPathWorking();
              });
          }
        },
        error: (err) => { },
      });
  }

  checkIfItemPathExists(itemName: string) {
    let idx = this.syncStoreItems.findIndex((item) => item.name == itemName);
    if (idx != -1) {
      return true;
    }
    return false;
  }

  ngAfterViewChecked() {
    if (this.autoScroll) {
      this.scrollToBottom();
      this.autoScroll = false;
    }
  }

  getStorageLogsdata() {
    this.checkStorageLogService = this.storageLogService.storageLogs.subscribe(
      (logs) => {
        logs.forEach((log) => {
          if (log.deployment == this.depName) {
            if (log.toShowAtStart == true) {
              let idx = this.StorageLogsData.findIndex(
                (storagelog) => storagelog.uniqueId == log.uniqueId
              );
              if (idx == -1 && !log.message.includes("Refreshing")) {
                this.addLogToStorageLogs(log);
              }
            }
            let idx = this.StorageLogsData.map(
              (storagelog) => storagelog.uniqueId
            ).lastIndexOf(log.uniqueId);
            if (idx != -1) {
              this.StorageLogsData[idx] = log;
              if (log.isRequestCompleted) {
                this.deactivateRefresh = false;
                this.storageLogService.removeLogFromStorageStore(log.uniqueId);
                if (this.defaultPath && !log.message.includes("Refreshing")) {
                  this.listFiles(this.defaultPath);
                }
              }
            }
          }
        });
      }
    );
  }

  maintainPathWorking() {
    this.dirPathSub?.unsubscribe();
    this.dirPathSub = this.storageService.jobStorageDirectory.subscribe(
      (path) => {
        // if any files are selected in multiselect, reset when jobstoragedirectory is changed
        this.multiSelectIndex = [];
        this.itemCopied = false;
        this.copiedFilePath = undefined;
        this.sourcePath = [];

        this.spinner.show("storageLoad");
        this.isBreadCrumbEditable = false;
        if (path != null) {
          if (
            this.leftPanelIndex == 4 ||
            path == this.userRootSyncStorePath ||
            (this.currentEntity != Entities.Jobs &&
              this.currentEntity != Entities.Deployments)
          ) {
            this.storageService.vmNodeName = false;
            this.counterErrorCount = 0;
            if (path == "" || path == "/mnt") {
              path = this.syncStorePath;
            }
            if (path != this.userRootWorkStorePath) {
              this.jobNodeName = null;
            } else {
              if (this.workStoreNodeChoosen != "All") {
                this.jobNodeSub = this.jobService.JobNode.subscribe((x) => {
                  if (x) {
                    if (x.includes(",")) {
                      this.jobNodeName = x.split(",")[0].trim();
                    } else {
                      this.jobNodeName = x;
                    }
                  }
                });
              } else {
                this.jobNodeName = null;
              }
            }
            this.syncStoreItems = null;
            this.filterItems = null;
            this.defaultPath = path;
            if (
              this.defaultPath == this.userRootSyncStorePath ||
              this.defaultPath.includes(this.syncStorePath)
            ) {
              this.dirName = this.currentLoggedInUser;
              this.activeStore = Store.SyncStore;
            } else {
              this.dirName = this.currentLoggedInUser;
              this.activeStore = Store.WorkStore;
            }
            this.isDownloadEnabled();
            this.isUploadEnabled();
            this.clearLogs();
            if (this.userNotAuthorized == true) {
              this.errorIfDataNotAvailable(0, false);
            }
            this.breadArr = path.split("/");
            this.manageBreadCrumbPath(this.defaultPath);
            this.multiSelectIndex = [];
            this.selectAll = false;
          } else {
            this.activeTabIndex = 0;
            this.counterErrorCount = 0;
            if (path == "") {
              path = this.env.envVariables.workStoreRoute;
            }
            if (this.jobNodeName) {
              this.jobNodeName = null;
            }
            this.jobNodeSub = this.jobService.JobNode.subscribe((x) => {
              if (x) {
                if (x.includes(",")) {
                  this.jobNodeName = x.split(",")[0].trim();
                } else {
                  this.jobNodeName = x;
                }
              }
            });
            this.breadArr = [];
            this.syncStoreItems = null;
            this.filterItems = null;
            if (!path.includes("workstore")) {
              this.activeStore = Store.SyncStore;
            } else {
              this.activeStore = Store.WorkStore;
            }
            this.isDownloadEnabled();
            this.isUploadEnabled();
            if (this.userNotAuthorized == true) {
              this.errorIfDataNotAvailable(0, false);
            }
            this.clearLogs();
            if (this.syncStoreCrumbs) {
              this.syncStoreCrumbs = [];
            }
            this.multiSelectIndex = [];
            this.selectAll = false;
            this.breadArr = path.split("/");

            let length = this.breadArr.length;
            for (let i = 2; i < length; i++) {
              this.defaultPath = this.breadArr.slice(0, i + 1).join("/");
              if (this.syncStoreCrumbs) {
                this.syncStoreCrumbs.forEach((element) => {
                  element.className = "";
                });
                this.syncStoreCrumbs.push(
                  new StorageDataLevel(
                    this.breadArr[i],
                    this.breadArr[i],
                    this.defaultPath,
                    "badge"
                  )
                );
              } else {
                this.syncStoreCrumbs = new Array(
                  new StorageDataLevel(
                    this.breadArr[i],
                    this.breadArr[i],
                    this.defaultPath,
                    "badge"
                  )
                );
              }
            }
          }
        } else {
          this.spinner.hide("storageLoad");
          this.errorIfDataNotAvailable(1, true);
        }
        this.listFiles(this.defaultPath);
      }
    );
  }

  sendStoreData(value: string) {
    this.clearLogs();
    if (this.storeDataReload) {
      this.storeDataReload.unsubscribe();
    }
    if (this.listFilesSub) {
      this.listFilesSub.unsubscribe();
    }
    if (value == Store.SyncStore) {
      this.isWorkStoreActive = false;
      this.workStoreNodeChoosen = "All";
      this.storageService.sendJobStorageDirectoryPath(
        this.userRootSyncStorePath
      );
      if( this.cloudType != CloudTypes.OnPremise ) {
        this.checkUtilityServiceRunning();
      }
    } else {
      this.isWorkStoreActive = true;
      this.storageService.sendJobStorageDirectoryPath(
        this.userRootWorkStorePath
      );
      this.checkUtilityServiceRunning();
    }
    this.isBreadCrumbEditable = false;
    this.getVmIp(this.selectedVmName);

  }

  workNodeData(nodeName: string) {
    this.workStoreNodeChoosen = nodeName;
    if (nodeName != "All") {
      this.jobService.sendJobNode(nodeName);
      if (this.env.envVariables.UseComputeNodeIpForUpload) {
        this.getVmIp(nodeName);
      }
    } else {
      this.getVmIp(nodeName);
    }
    if (this.storeDataReload) {
      this.storeDataReload.unsubscribe();
    }
    if (this.listFilesSub) {
      this.listFilesSub.unsubscribe();
    }
    this.storageService.sendJobStorageDirectoryPath(this.userRootWorkStorePath);
    this.isBreadCrumbEditable = false;
  }

  getVmIp(nodeName: string) {
    this.selectedVmName = nodeName;
    this.storageService
      .getVmIP(this.depName, this.selectedVmName)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.fileUploadHeadNodeIP = JSON.parse(JSON.stringify(data.vmIp));
          this.updateFileuploadUrl(this.fileUploadHeadNodeIP);
          if (this.cloudType == CloudTypes.OnPremise) {
            this.utilityService
              .checkIfUtilityServiceActive(this.fileUploadHeadNodeIP, this.depName)
              .pipe(takeUntil(this.destroy$))
              .subscribe();
          }
        },
        error: (err) => { },
      });
  }

  createDirectory(dirName: string) {
    if (!dirName) return;
    
    dirName = dirName.trim().replace(/ /g, "_");
    
    if (this.createDirSub) {
      this.createDirSub.unsubscribe();
    }
    
    this.uniqueLogId += 1;
    let newLogObj: StorageLogs = this.storageLogService.createLogObject(this.uniqueLogId, this.depName, 3, dirName,
      this.defaultPath, `Creating Folder "${dirName}" : `, "Pending", false);
    this.addLogToStorageLogs(newLogObj);
    this.autoScroll = true;
    

    const context: FileOperationContext = {
      deploymentName: this.depName,
      nodeName: this.getActiveWorkstoreNodeName() || undefined,
      currentPath: this.defaultPath,
      cloudType: this.cloudType,
      activeStore: this.activeStore,
      currentStorageName: this.currentStorageName,
      userInfo: { 
        username: this.currentLoggedInUser, 
        role: this.currentLoggedInUserRole 
      }
    };

    this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath);
    
    this.storageStrategy.createDirectory(dirName, this.defaultPath, context, this.uniqueLogId)
      .subscribe({
        next: (result: OperationResult) => {
          if (!result.success) {
            this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
          }
        },
        error: (error) => {
          console.error(`Directory creation failed for ${dirName}:`, error);
          this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
          this.actionLogService.addActionLog(this.depName, "Create Directory", dirName, this.currentStorageName, "Storage", `Failed`);

        },
        complete: () => {
          this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Completed");
          this.actionLogService.addActionLog(this.depName, "Create Directory", dirName, this.currentStorageName, "Storage", `Created`);
        }
      });

    setTimeout(() => {
      this.listFiles(this.defaultPath);
    }, 500);
  }

  renameFileDirect(newName: string, prevName: string, type: string) {
    if (newName) {
      newName = newName.trim();
      newName = newName.replace(/ /g, "_");
      if (this.createDirSub) {
        this.createDirSub.unsubscribe();
      }
      let dirPath = this.defaultPath;
      this.uniqueLogId += 1;
      let currFileName = prevName.split("/")[prevName.split("/").length - 1];
      let newLogObj: StorageLogs = this.storageLogService.createLogObject(this.uniqueLogId, this.depName,
        3, newName, this.defaultPath, `Renaming "${currFileName}" to "${newName}" : `, "Pending", false);
      this.addLogToStorageLogs(newLogObj);
      this.autoScroll = true;
      this.actionLogService.addActionLog(this.depName, "Rename", currFileName,
        this.currentStorageName, "Storage", `Renaming File/Directory ${currFileName} to ${newName}`);
      var fileDirectoryName = newName;

      if (
        this.renameSupportedCloudTypes.filter((type) => type != CloudTypes.MicrosoftAzure)
        .includes(this.cloudType as any) || dirPath.includes(this.env.envVariables.workStoreRoute)
      ) {
        // Handle OnPremise, AWS, Google, Oracle cloud types
        if (this.defaultPath != ".") {
          newName = this.defaultPath + "/" + newName;
        }
        var storageDataType: StorageDataType = {
          name: fileDirectoryName,
          type: type,
          path: this.defaultPath,
        };
        this.storageService
          .rename(this.depName, storageDataType, prevName, this.jobNodeName)
          .subscribe({
            next: (data) => {
              this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Completed");
            },
            error: () => {
              this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
            },
          });
      } else if (this.cloudType == CloudTypes.MicrosoftAzure) {
        // Handle Azure storage - check if it's blob or file storage
        if (this.checkIfStorageIsBlobForAzure()) {
          // Azure Blob Storage rename logic - use the new renameBlob method
          let oldBlobPath = this.defaultPath + "/" + currFileName;
          let newBlobPath = this.defaultPath + "/" + fileDirectoryName;

          // For directories in blob storage, handle with trailing slash
          if (type === "directory") {
            oldBlobPath += "/";
            newBlobPath += "/";
          }

          // Use the new renameBlob method
          this.storageDataTransferService
            .renameBlob(oldBlobPath, newBlobPath)
            .subscribe({
              next: (data) => {
                this.autoScroll = true;
                this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Completed");
              },
              error: (error) => {
                this.autoScroll = true;
                this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
              },
            });
        } else {
          // Azure Files rename logic (existing)
          this.storageDataTransferService.azureFilesRename(prevName, fileDirectoryName, this.uniqueLogId);
        }
      }
    }
    setTimeout(() => {
      this.listFiles(this.defaultPath);
    }, 500);
  }

  downloadFile() {
    if (this.multiSelectIndex.length == 0) {
      this.snackBar.open("No file / folder selected, Unable to Download.", "Ok", { duration: 3000 });
      return;
    }

    this.multiSelectIndex.forEach((item) => {
      this.uniqueLogId += 1;
      const currentUniqueId = this.uniqueLogId; // Capture the ID
      
      let newLogObj: StorageLogs = this.storageLogService.createLogObject(currentUniqueId, this.depName, 2, // Download type
        item.name, item.path, `Download started for ${item.name} : `, "Pending", true);
      this.addLogToStorageLogs(newLogObj);

      const context: FileOperationContext = {
        deploymentName: this.depName,
        nodeName: this.getActiveWorkstoreNodeName() || undefined,
        currentPath: this.defaultPath,
        cloudType: this.cloudType,
        activeStore: this.activeStore,
        currentStorageName: this.currentStorageName,
        fileName: item.name,
        fileType: item.type,
        userInfo: { 
          username: this.currentLoggedInUser, 
          role: this.currentLoggedInUserRole,
          headNodeIP: this.fileUploadHeadNodeIP,
          routeViaSynchpc: this.routeViaSynchpc
        }
      };

      this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath);
      
      this.storageStrategy.downloadFile(item.path, context, currentUniqueId).subscribe({
        next: (result: DownloadResult) => {
          if ((result as any).cancelled || result.blob === null) {
            return;
          }
          
          if (result.directDownload && result.blob) {
            this.downloadBlob(result.fileName || item.name, result.blob);
          } else if (result.url) {
            window.open(result.url, "_blank");
          }
        },
        error: (error) => {
          if (error.message && error.message.includes('cancelled')) {
            return;
          }

          if(item.type != 'file'){
            this.snackBar.open(`Download failed for ${item.name}: Directory Can't be downloaded`, "Ok", { duration: 5000 });
          }else{
            console.error(`Download failed for ${item.name}:`, error);
            this.snackBar.open(`Download failed for ${item.name}`, "Ok", { duration: 5000 });
          }
        }
      });
    });
    
    this.multiSelectIndex = [];
    this.selectAll = false;
  }

  cancelOperation(log: StorageLogs) {
    
    const operationMap = {
      1: { name: 'upload', action: 'Upload' },
      2: { name: 'download', action: 'Download' },
      3: { name: 'general', action: 'Operation' },
      4: { name: 'zip', action: 'Zip' },
      5: { name: 'unzip', action: 'Unzip' }
    };

    const operation = operationMap[log.logType];
    
    if (!operation) {
      return;
    }

    try {
      let cloud = this.cloudType;
      if(operation.name === 'zip' || operation.name === 'unzip'){
        cloud = CloudTypes.OnPremise; // Zip/Unzip operations are handled by OnPremise strategy
      }
      this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath);
      const cancelled = this.storageStrategy.cancelOperation(log.uniqueId, operation.name as any);
      
      if (cancelled) {
        this.snackBar.open(`${operation.action} cancelled successfully`, "Ok", { duration: 3000 });
      } else {
        this.snackBar.open(`${operation.action} could not be cancelled`, "Ok", { duration: 3000 });
      }
    } catch (error) {
      console.error(` Error cancelling ${operation.name}:`, error);
      
      if (error.message && error.message.includes('abort is not a function')) {
        this.snackBar.open(`${operation.action} cancelled`, "Ok", { duration: 3000 });
      } else {
        this.snackBar.open(`Failed to cancel ${operation.name}`, "Ok", { duration: 5000 });
      }
    }
  }

  private downloadBlob(filename: string, blob: Blob) {
    filename = filename.replace(/['"]+/g, "");
    let url = window.URL.createObjectURL(blob);
    let elementAnchor = document.createElement("a");
    document.body.appendChild(elementAnchor);
    elementAnchor.setAttribute("style", "display: none");
    elementAnchor.href = url;
    elementAnchor.download = filename;
    elementAnchor.click();
    window.URL.revokeObjectURL(url);
    elementAnchor.remove();
  }

  downloadFileRightClick(item: any) {
    this.downloadFile();
  }


  onRightClick() {
    return false;
  }

  onFileRightClick(item, event: any) {
    if (this.multiSelectIndex.length > 1) {
      this.snackBar.open(
        "Right-click menu only works with single selection, Check highlighted Buttons",
        "OK",
        {
          duration: 3000,
        }
      );
      event.preventDefault();
      return;
    }

    if (this.isMonitor) {
      return;
    }
    this.multiSelectIndex = [];
    this.selectAll = false;
    this.lastClickedIdx = item;
    if (!this.multiSelectIndex.includes(item)) {
      this.multiSelectIndex.push(item);
    }
  }

  get highlightActionButtonOnMultiSelect(): boolean {
    return this.multiSelectIndex?.length > 1;
  }

  fileChanged() {
    alert("clicked me! fileChanged");
  }

  listFiles(dirName: string, uniqueId?: number) {
    // this.storageDataTransferService.createContainer("Akash").subscribe();

    this.currentRequestId++;
    const requestId = this.currentRequestId;
    if (this.env.envVariables.restrictStorageAccess) {
      let tempPath = this.defaultPath;

      if (
        this.cloudType == CloudTypes.MicrosoftAzure &&
        !this.defaultPath?.includes(this.syncStorePath) &&
        !this.defaultPath?.includes(this.env.envVariables.workStoreRoute)
      ) {
        tempPath = this.syncStorePath + "/" + dirName;
      }

      if (
        tempPath != this.syncStorePath &&
        !this.authorizeFolderAccess(tempPath) &&
        tempPath != this.workStorePath
      ) {
        this.errorIfDataNotAvailable(2, true);
        this.spinner.hide("storageLoad");
        return;
      }

      this.defaultPath = tempPath;
    }

    if (!dirName) {
      this.errorIfDataNotAvailable(5, true);
      return;
    }
    if (dirName.includes(this.syncStorePath)) {
      this.storageService.vmNodeName = false;
    }
    if (dirName.includes(this.env.envVariables.workStoreRoute)) {
      this.storageService.vmNodeName = true;
    }
    if (this.defaultPath != dirName) {
      this.resetStorageSearch();
      this.config.currentPage = 1;
    }
    if (
      !this.defaultPath.includes(this.syncStorePath) &&
      !this.defaultPath.includes(this.env.envVariables.workStoreRoute)
    ) {
      this.breadCrumbPath =
        (this.activeStore == Store.SyncStore
          ? this.syncStorePath
          : this.env.envVariables.workStoreRoute) +
        "/" +
        this.defaultPath;
    } else {
      this.breadCrumbPath = this.defaultPath;
    }
    let nodeName = this.getActiveWorkstoreNodeName();
    const context: FileOperationContext = {
        deploymentName: this.depName,
        nodeName: this.getActiveWorkstoreNodeName() || undefined,
        currentPath: dirName,
        defaultCurrentPath: this.defaultPath,
        cloudType: this.cloudType,
        activeStore: this.activeStore,
        currentStorageName: this.currentStorageName,
        userInfo: { username: this.currentLoggedInUser, role: this.currentLoggedInUserRole }
    };  
    this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, dirName);
    if(dirName.includes(this.env.envVariables.workStoreRoute)) {
        if(this.listFilesSub) this.listFilesSub.unsubscribe();
        this.listFilesSub = this.storageService.ListFiles(dirName, this.depName, nodeName).pipe(takeUntil(this.destroy$))
        .subscribe({
            next: (data) => {
                if (requestId !== this.currentRequestId) {
                  return; // Ignore outdated response
                }
                this.counterErrorCount = 0;
                if(this.storeDataReload){
                    this.storeDataReload.unsubscribe();
                }
                this.syncStoreItems = JSON.parse(JSON.stringify(data));
                if(this.syncStoreItems?.length < this.config.itemsPerPage){
                    this.config.currentPage = 1;
                }
                this.filterItems = JSON.parse(JSON.stringify(data));
                if(this.syncStoreItems.length != 0 && this.syncStoreItems[0].type == "error"){
                    this.errorIfDataNotAvailable(2, true);
                }else{
                    this.errorIfDataNotAvailable(0, false);
                }
                this.spinner.hide("storageLoad");
                this.selectAll = false;
                this.storeDataReload = interval(this.syncConfig.config.storages.filesReqInterval)
                .subscribe(() => {
                    this.listFiles(this.defaultPath);
                    this.navService.sendLastUpdate(
                        this.headerService.getUserNewDate()
                    );
                });
                if(data.length == 0){
                    this.errorIfDataNotAvailable(3, true);
                }
                this.storageLogService.updateRequestCompleteFields(uniqueId, "Completed");
                this.applySearchFilter();
            },
            error: (error) => {
                if(this.leftPanelIndex == 4 || this.defaultPath == this.syncStorePath || 
                    (this.currentEntity != Entities.Jobs && this.currentEntity != "Deployments")
                ){
                    this.errorIfDataNotAvailable(4, true);
                    this.storageLogService.updateRequestCompleteFields(uniqueId, "Failed");
                    this.spinner.hide("storageLoad");
                }
                else{
                    if(dirName.length > (this.env.envVariables.workStoreRoute.length || this.syncStorePath.length)){
                        this.defaultPath = this.breadArr.slice(0, -1).join("/");
                        this.storageService.sendJobStorageDirectoryPath(this.defaultPath);
                    }
                    else{
                        this.errorIfDataNotAvailable(4, true);
                        this.spinner.hide("storageLoad");
                    }
                }
            },
        });
    }
    else{
        const cancelContext = {
          recentlyCancelled: Array.from(this.recentlyCancelledFiles),
          currentPath: this.defaultPath,
        };

      this.listFilesSub = this.storageStrategy.listFiles(this.defaultPath, context, uniqueId, cancelContext).pipe(takeUntil(this.destroy$))
        .subscribe({
            next: (data) => {
              if (requestId !== this.currentRequestId) {
                return; // Ignore outdated response
              }
                this.counterErrorCount = 0;
                if(this.storeDataReload){
                    this.storeDataReload.unsubscribe();
                }
                this.syncStoreItems = JSON.parse(JSON.stringify(data));
                if(this.syncStoreItems?.length < this.config.itemsPerPage){
                    this.config.currentPage = 1;
                }
                this.filterItems = JSON.parse(JSON.stringify(data));
                if(this.syncStoreItems.length != 0 && this.syncStoreItems[0].type == "error"){
                    this.errorIfDataNotAvailable(2, true);
                }else{
                    this.errorIfDataNotAvailable(0, false);
                }
                this.spinner.hide("storageLoad");
                this.selectAll = false;
                this.storeDataReload = interval(this.syncConfig.config.storages.filesReqInterval)
                    .subscribe(() => {
                        this.listFiles(this.defaultPath);
                        this.navService.sendLastUpdate(
                            this.headerService.getUserNewDate()
                        );
                    });
                if(data.length == 0){
                    this.errorIfDataNotAvailable(3, true);
                }
                this.storageLogService.updateRequestCompleteFields(uniqueId, "Completed");
                this.applySearchFilter();
            },
            error: (error) => {
                if(this.leftPanelIndex == 4 || this.defaultPath == this.syncStorePath || 
                    (this.currentEntity != Entities.Jobs && this.currentEntity != "Deployments")
                ){
                    this.errorIfDataNotAvailable(4, true);
                    this.storageLogService.updateRequestCompleteFields(uniqueId, "Failed");
                    this.spinner.hide("storageLoad");
                }
                else{
                    if(dirName.length > (this.env.envVariables.workStoreRoute.length || this.syncStorePath.length)){
                        this.defaultPath = this.breadArr.slice(0, -1).join("/");
                        this.storageService.sendJobStorageDirectoryPath(this.defaultPath);
                    }
                    else{
                        this.errorIfDataNotAvailable(4, true);
                        this.spinner.hide("storageLoad");
                    }
                }
            },
        });
    }
  }

  deleteFile() {
    if (this.multiSelectIndex.length == 0) {
      if (this.snackBar) this.snackBar.dismiss();
      this.snackBar.open("No file / folder selected, Unable to Delete.", "Ok", { duration: 3000 });
      return;
    }

    this.deleteFileData = [];
    this.multiSelectIndex.forEach((i) => {
      this.deleteFileData.push({
        type: i.type,
        name: i.name,
        store: this.activeStore,
      });
    });

    if (this.deleteFileData.length != 0 && this.multiSelectIndex.length != 0) {
      const dialogRef = this.dialog.open(DeleteConfirmComponent, {
        autoFocus: false,
        disableClose: true,
        width: "400px",
        data: this.deleteFileData,
      });

      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.multiSelectIndex.forEach((clickedItem) => {
            const fileName = clickedItem.name;
            
            if (this.multiSelectIndex?.length == 1) {
              if (!this.defaultPath.includes("workstore") && !this.authorizeFolderAccess(`${this.defaultPath}/${clickedItem.name}`)) {
                this.snackBar.open("You are not authorized to delete this folder/file.", "Ok", { duration: 5000 });
                return;
              }
            } else {
              if (!this.authorizeFolderAccess(clickedItem.path)) {
                this.snackBar.open("You are not authorized to delete this folder/file.", "Ok", { duration: 5000 });
                return;
              }
            }


            this.uniqueLogId += 1;
            let newLogObj: StorageLogs = this.storageLogService.createLogObject(this.uniqueLogId, this.depName, 3, fileName, this.defaultPath,
              `Deleting ${clickedItem.type} "${clickedItem.name}" : `, "Pending", false);
            this.addLogToStorageLogs(newLogObj);

            const context: FileOperationContext = {
              deploymentName: this.depName,
              nodeName: this.getActiveWorkstoreNodeName() || undefined,
              currentPath: this.defaultPath,
              cloudType: this.cloudType,
              activeStore: this.activeStore,
              currentStorageName: this.currentStorageName,
              fileName: fileName,
              syncStorePath: this.syncStorePath,
              userInfo: { 
                username: this.currentLoggedInUser, 
                role: this.currentLoggedInUserRole 
              }
            };

            try {
              this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath);

              this.storageStrategy.deleteFile(clickedItem.path, context, this.uniqueLogId)
                .subscribe({
                  next: (result: OperationResult) => {
                    this.autoScroll = true;
                    this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, result.success ? "Completed" : "Failed");
                    this.actionLogService.addActionLog(this.depName, "Delete", fileName, this.currentStorageName, "Storage", 
                      `Deleting ${clickedItem.type} "${clickedItem.name}"`, 2, result.success ? "Successful" : "Failed");
                    
                    if (result.success) {
                      setTimeout(() => {
                        this.listFiles(this.defaultPath);
                      }, 500);
                    }
                  },
                  error: (error) => {
                    this.autoScroll = true;
                    
                    if (error.message && error.message.includes('405')) {
                      this.snackBar.open("You are not authorized to delete this Folder/File.", "Ok", { duration: 5000 });
                    }
                    this.actionLogService.addActionLog(this.depName, "Delete", fileName, this.currentStorageName, "Storage", 
                              `Deleting ${clickedItem.type} "${clickedItem.name}"`, 2, "Failed");

                    this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
                  }
                });
            } catch (error) {
              console.error(`Failed to delete ${fileName}:`, error);
              this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
            }
          });

          this.multiSelectIndex = [];
          this.selectAll = false;
          this.deleteFileData = [];
        } else {
          this.multiSelectIndex = [];
          this.selectAll = false;
          this.deleteFileData = [];
        }
      });
    }
  }

  private scrollToBottom(): void {
    if (this.disableScrollDown) {
      return;
    }
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  activateClass(item: StorageDataType) {
    let idx = this.multiSelectIndex.findIndex((it) => it.name == item.name);
    if (idx == -1) {
      this.multiSelectIndex.push(item);
      if (this.multiSelectIndex.length == this.syncStoreItems.length) {
        this.selectAll = true;
      }
    } else {
      this.multiSelectIndex.splice(idx, 1);
      if (
        this.multiSelectIndex.length == 0 ||
        this.multiSelectIndex.length != this.syncStoreItems.length
      ) {
        this.selectAll = false;
      }
    }
  }

  async blobToString(blob) {
    const fileReader = new FileReader();
    return new Promise((resolve, reject) => {
      fileReader.onloadend = (ev) => {
        resolve(ev.target.result);
      };
      fileReader.onerror = reject;
      fileReader.readAsText(blob);
    });
  }

  download(filename, fileData) {
    filename = filename.replace(/['"]+/g, "");
    let url = window.URL.createObjectURL(fileData);
    let elementAnchor = document.createElement("a");
    document.body.appendChild(elementAnchor);
    elementAnchor.setAttribute("style", "display: none");
    elementAnchor.href = url;
    elementAnchor.download = filename;
    elementAnchor.click();
    window.URL.revokeObjectURL(url);
    elementAnchor.remove();
    this.actionLogService.addActionLog(
      this.depName,
      "Download",
      filename,
      this.currentStorageName,
      "Storage",
      `Downloading ${filename}`
    );
  }

  onSelectAllCheckBox(isChecked) {
    if (isChecked) {
      this.selectAll = true;
      let filteredItems: StorageDataType[] = this.syncStoreItems.filter(
        (v) =>
          v.name.toLowerCase().indexOf(this.storageSearch?.toLowerCase()) > -1
      );
      filteredItems.forEach((element) => {
        if (!this.multiSelectIndex.find((el) => el.name == element.name)) {
          this.multiSelectIndex.push(element);
        }
      });
    } else {
      this.multiSelectIndex = [];
      this.selectAll = false;
    }
  }

  refreshFiles() {
    this.deactivateRefresh = true;
    this.uniqueLogId += 1;
    let logMsg = `Refreshing files/folders of path "${this.defaultPath}" : `;
    if (
      this.cloudType != CloudTypes.OnPremise &&
      this.defaultPath !=
      (this.syncStorePath || this.env.envVariables.workStoreRoute)
    ) {
      if (this.activeStore == Store.WorkStore) {
        if (logMsg.indexOf(this.env.envVariables.workStoreRoute) == -1) {
          logMsg = `Refreshing files/folders of path "${this.env.envVariables.workStoreRoute}/${this.defaultPath}" : `;
        }
      } else {
        if (logMsg.indexOf(this.syncStorePath) == -1) {
          logMsg = `Refreshing files/folders of path "${this.syncStorePath}/${this.defaultPath}" : `;
        }
      }
    }
    let newLogObj: StorageLogs = this.storageLogService.createLogObject(
      this.uniqueLogId,
      this.depName,
      3,
      null,
      this.defaultPath,
      logMsg,
      "Pending",
      false
    );
    this.addLogToStorageLogs(newLogObj);
    this.autoScroll = true;
    this.listFiles(this.defaultPath, this.uniqueLogId);
    if (this.syncStoreItems == null) {
      this.spinner.show("storageLoad");
    }
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.multiSelectIndex = [];
    this.selectAll = false;
  }

  errorIfDataNotAvailable(errorType: number, toShowError: boolean) {
    if (toShowError) {
      if (errorType == 1) {
        this.errorMsg = StorageErrorTypes.WorkDirectoryNotCreated;
      } else if (errorType == 2) {
        this.errorMsg = StorageErrorTypes.PermissionDenied;
      } else if (errorType == 3) {
        this.errorMsg = StorageErrorTypes.DirectoryEmpty;
      } else if (errorType == 4) {
        this.errorMsg = StorageErrorTypes.UnknownError;
      } else if (errorType == 5) {
        this.errorMsg = StorageErrorTypes.PathNotFound;
      }
      this.userNotAuthorized = true;
      this.syncStoreItems = [];
      this.filterItems = [];
    } else {
      this.errorMsg = null;
      this.userNotAuthorized = false;
      this.spinner.show("storageLoad");
    }
  }

  // when breadcrumb/folder naviation is requested
  onNavigation(
    breadcrumbElement: StorageDataLevel,
    itemClicked: StorageDataType,
    i
  ): void {
    this.spinner.show("storageLoad");
    this.multiSelectIndex = [];
    this.selectAll = false;
    if (itemClicked) {
      this.onFileFolderClick(itemClicked, i);
    } else {
      this.onBreadCrumbClick(breadcrumbElement);
    }
    this.config.currentPage = 1;
  }

  // for folder navigation
  onFileFolderClick(itemClicked: StorageDataType, i) {
    var path = itemClicked.path;
    var lastCrumb = this.syncStoreCrumbs[this.syncStoreCrumbs.length - 1];
    if (
      this.cloudType == CloudTypes.MicrosoftAzure &&
      this.env.envVariables.restrictStorageAccess
    ) {
      if (!this.authorizeFolderAccess(path)) {
        this.spinner.hide("storageLoad");
        this.snackBar.open(
          "You do not have permission to access this folder.",
          "OK",
          { duration: 5000 }
        );
        return;
      }
    }
    if (itemClicked.type != "file") {
      this.defaultPath = path;
    }
    if (lastCrumb.path !== path) {
      //check for same level click
      if (itemClicked.type == "directory") {
        if (this.storeDataReload) {
          this.storeDataReload.unsubscribe();
        }
        //New Directory Click
        //Remove Class from all previous elements
        this.syncStoreCrumbs.forEach((element) => {
          element.className = "";
        });
        //Push New Directory
        this.manageBreadCrumbPath(path);
        this.jobService.sendScrollUpData(true);
        this.resetStorageSearch();
      } else {
        // download file
        this.multiSelectIndex.push(itemClicked);
        if (this.showDownloadBtn) {
          this.downloadFile();
          this.resetStorageSearch();
        }
      }
      // this.spinner.hide('storageLoad')
      this.listFiles(this.defaultPath);
    } else {
      this.spinner.hide("storageLoad");
    }
  }

  // for breadcrumb navigation
  onBreadCrumbClick(element: StorageDataLevel) {
    var path = element.path;
    var name = element.name;
    if (
      this.cloudType == CloudTypes.MicrosoftAzure &&
      this.env.envVariables.restrictStorageAccess
    ) {
      if (!this.authorizeFolderAccess(path)) {
        this.spinner.hide("storageLoad");
        this.snackBar.open(
          "You do not have permission to access this folder.",
          "OK",
          { duration: 5000 }
        );
        return;
      }
    }
    var lastCrumb = this.syncStoreCrumbs[this.syncStoreCrumbs.length - 1];
    if (lastCrumb.path !== path) {
      //Old Directory Click
      this.defaultPath = path;
      const index = this.syncStoreCrumbs.findIndex((c) => c.path == path);
      this.syncStoreCrumbs[index].className = "badge";
      this.syncStoreCrumbs.splice(index + 1);
      this.resetStorageSearch();
      this.listFiles(this.defaultPath);
      if (this.userNotAuthorized == true) {
        this.syncStoreItems = [];
        this.filterItems = [];
        this.errorIfDataNotAvailable(0, false);
      }
    } else this.spinner.hide("storageLoad");
  }

  openCreateDirectoryDialog() {
    const dialogRef = this.dialog.open(CreateDirectoryComponent, {
      autoFocus: false,
      disableClose: true,
      width: "350px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.multiSelectIndex = [];
        this.selectAll = false;
        this.createDirectory(result);
        setTimeout(() => {
          this.listFiles(this.defaultPath);
        }, 500);
      }
    });
  }

  clearLogs() {
    this.StorageLogsData = this.StorageLogsData.filter(
      (log) => !log.isRequestCompleted || log.toShowAtStart
    );
    this.StorageLogsData.forEach((log) => {
      if (log.isRequestCompleted && log.toShowAtStart)
        log.toShowAtStart = false;
    });
    this.jobService.sendScrollUpData(true);
  }

  showFileData(item: any) {
    if (item) {
      if (this.cloudType != CloudTypes.OnPremise) {
        if (this.activeStore == Store.SyncStore) {
          if (!item.path.includes(this.syncStorePath)) {
            item.path = `${this.syncStorePath}/${item.path}`;
          }
        }
      }

      const fileItem: FileTab = {
        deploymentName: this.depName,
        fileName: item.name,
        filePath: item.path,
        totalLines: -1,
        content: null,
        closed: false,
        entityType:
          this.currentEntity == Entities.Jobs
            ? Entities.Jobs
            : Entities.Storages,
      };
      this.multiSelectIndex = [];

      const existsIdx = this.tabsAvailable.findIndex(
        (tab) => tab.filePath == fileItem.filePath
      );
      if (existsIdx != -1) {
        this.activeTabIndex = existsIdx + 1;
        return;
      }
      this.tabsAvailable.push(fileItem);
      this.storageService.addViewFileCacheData(fileItem);
      this.activeTabIndex = this.tabsAvailable.length;
    }
  }

  deleteFileRightClick(item: any) {
    this.deleteFile();
  }

  copyRightClick(item: any) {
    if (this.onTableBodyRightClickForMultipleSelect()) {
      this.copyMultiple();
      return;
    }
    this.itemCopied = true;
    this.copiedFilePath = item.path;
    // Handle Azure Blob Storage
    if (this.cloudType == CloudTypes.MicrosoftAzure && this.checkIfStorageIsBlobForAzure()) {
      if (!this.copiedFilePath.includes(this.syncStorePath) &&
        !this.copiedFilePath.includes(this.env.envVariables.workStoreRoute)) {
        if (this.activeStore == Store.SyncStore) {
          this.copiedFilePath = `${this.syncStorePath}/${this.copiedFilePath}`;
        } else {
          this.copiedFilePath = `${this.env.envVariables.workStoreRoute}/${this.copiedFilePath}`;
        }
      }
    }
    if (!this.sourcePath.includes(this.copiedFilePath))
      this.sourcePath.push(this.copiedFilePath);
  }

  renameRightClick(item: any) {
    const dialogRef = this.dialog.open(RenameComponent, {
      autoFocus: false,
      disableClose: true,
      width: "450px",
      data: {
        depName: this.depName,
        path: item.path,
        vmNodeName: this.jobNodeName,
        name: item.name,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.multiSelectIndex = [];
        this.selectAll = false;
        this.clickedForRename = item.path;
        this.renameFileDirect(result, this.clickedForRename, item.type);
        setTimeout(() => {
          this.listFiles(this.defaultPath);
        }, 500);
      }
    });
  }

  copyMultiple() {
    if (this.multiSelectIndex.length == 0) {
      this.snackBar.open("No file / folder selected, Unable to Copy.", "Ok", {
        duration: 3000,
      });
      return;
    }
    this.itemCopied = true;
    this.sourcePath = [];
    this.multiSelectIndex.forEach((i) => {
      this.sourcePath.push(i.path);
    });
    this.multiSelectIndex = [];
    this.selectAll = false;
    this.snackBar.open("Selected files/folders for copy", "Ok", {
      duration: 3000,
    });
  }

  async pasteRightClick(item?: any) {
    if (this.sourcePath.length == 0) {
      this.snackBar.open("No file / folder selected, Unable to Paste.", "Ok", {
        duration: 3000,
      });
      return;
    }
    this.destinationPath = this.defaultPath;
    if (this.multiSelectIndex.length == 1) {
      let clickedItem = this.multiSelectIndex[0];
      if (clickedItem.type != "file") {
        this.destinationPath = clickedItem.path;
      }
    }

    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (this.destinationPath != this.syncStorePath) {
        if (
          this.activeStore == Store.SyncStore &&
          this.destinationPath != this.syncStorePath
        ) {
          if (this.destinationPath.includes("syncstore")) {
            let x = this.destinationPath
              .split("/")
              .filter((e) => e != "syncstore" && e != "mnt")
              .filter((element) => element.trim() !== "");
            this.destinationPath = x.join("/");
          }
          this.destinationPath = `${this.syncStorePath}/${this.destinationPath}`;
        } else {
          if (
            !this.destinationPath.includes(this.env.envVariables.workStoreRoute)
          ) {
            this.destinationPath = `${this.env.envVariables.workStoreRoute}/${this.destinationPath}`;
          }
        }
      }
      this.sourcePath = this.handleStorePathForAzure(this.sourcePath);
    }

    const existingFiles = [];
    for (const sourcePath of this.sourcePath) {
      const fileName = sourcePath.split("/").pop();
      const fileExists = await this.checkIfItemPathExists(fileName);
      if (fileExists) {
        existingFiles.push(fileName);
      }
    }
    if (existingFiles.length > 0) {
      this.spinner.hide("storageLoad");
      const fileNames = existingFiles.length === 1 ? existingFiles[0] : `${existingFiles.length} files`;
      const message = existingFiles.length === 1
        ? `A file/folder with the name "${existingFiles[0]}" already exists at "${this.destinationPath}". Please choose an action to perform.`
        : `${existingFiles.length} files/folders already exist at "${this.destinationPath}": ${existingFiles.join(', ')}. Please choose an action to perform.`;

      const result = await lastValueFrom(
        this.dialog
          .open(FileAlreadyExistsActionComponent, {
            autoFocus: false,
            disableClose: true,
            width: "40vw",
            data: {
              title: "File/Folder already exists",
              message: message,
              showAllButtons: false,
            },
          })
          .afterClosed()
      );
      if (result !== 2) {
        this.resetCopiedData();
        return;
      }
      this.spinner.show("storageLoad");
    }

    // Check if it's Azure Blob Storage
    if (this.cloudType == CloudTypes.MicrosoftAzure && this.checkIfStorageIsBlobForAzure()) {
      // Handle blob storage copy-paste
      this.handleBlobCopyPaste();
    } else {
      // Handle regular storage copy-paste
      this.handleRegularCopyPaste();
    }
  }

  handleBlobCopyPaste() {
    this.uniqueLogId += 1;
    let newLogObj: StorageLogs = this.storageLogService.createLogObject(
      this.uniqueLogId,
      this.depName,
      3,
      null,
      this.defaultPath,
      `Copying "${this.sourcePath[0]}" to "${this.destinationPath}" : `,
      "Pending",
      false
    );
    this.addLogToStorageLogs(newLogObj);

    // Process each source path for blob copy
    const copyObservables = this.sourcePath.map((sourcePath) => {
      const fileName = sourcePath.split("/").pop();
      const destinationFilePath = `${this.destinationPath}/${fileName}`;

      return this.storageDataTransferService.copyBlob(sourcePath, destinationFilePath);
    });

    // Use forkJoin to handle multiple observables
    forkJoin(copyObservables).subscribe({
      next: (results) => {
        this.storageLogService.updateRequestCompleteFields(
          newLogObj.uniqueId,
          "Completed"
        );
        this.spinner.hide("storageLoad");
        this.resetCopiedData();
        this.listFiles(this.defaultPath);
        this.snackBar.open("Files copied successfully", "Ok", {
          duration: 3000,
        });
      },
      error: (error) => {
        this.storageLogService.updateRequestCompleteFields(
          newLogObj.uniqueId,
          "Failed"
        );
        this.resetCopiedData();
        this.spinner.hide("storageLoad");
        this.snackBar.open("Failed to copy files", "Ok", {
          duration: 5000,
        });
      }
    });
  }

  // Remove the manual copyBlobFile and copyBlobDirectory methods since we're using the service method now

  handleRegularCopyPaste() {
    let data: CopyPasteObj = {
      SourcePaths: this.sourcePath,
      DestinationPath: this.destinationPath,
    };
    this.uniqueLogId += 1;
    let newLogObj: StorageLogs = this.storageLogService.createLogObject(
      this.uniqueLogId,
      this.depName,
      3,
      null,
      this.defaultPath,
      `Copying "${this.sourcePath[0]}" to "${this.destinationPath}" : `,
      "Pending",
      false
    );
    this.addLogToStorageLogs(newLogObj);
    let nodeName = this.getActiveWorkstoreNodeName();
    this.storageService.copyPasteFile(this.depName, data, nodeName).subscribe({
      next: (data) => {
        this.storageLogService.updateRequestCompleteFields(
          newLogObj.uniqueId,
          "Completed"
        );
        this.spinner.hide("storageLoad");
        this.resetCopiedData();
        this.listFiles(this.defaultPath);
        this.snackBar.open("Files copied successfully", "Ok", {
          duration: 3000,
        });
      },
      error: (err) => {
        this.storageLogService.updateRequestCompleteFields(
          newLogObj.uniqueId,
          "Failed"
        );
        this.resetCopiedData();
        this.spinner.hide("storageLoad");
        let errorMessage = "Failed to paste files";
        if (typeof err.error === 'string') {
          try {
            const errorData = JSON.parse(err.error);
            errorMessage = errorData.message || errorMessage;
          } catch (e) {
          }
        } else if (err.error?.message) {
          errorMessage = err.error.message;
        }
        this.snackBar.open(errorMessage, "Ok", {
          duration: 5000,
        });
      },
    });
  }
  resetCopiedData() {
    this.itemCopied = false;
    this.copiedFilePath = undefined;
    this.sourcePath = [];
    this.listFiles(this.defaultPath);
  }

  resetStorageSearch() {
    this.filterSearch.setValue("");
  }

  inpDbClick() {
    return false;
  }

  returnFalse() {
    return false;
  }

  toShowUpload() {
    if (this.activeStore == Store.SyncStore) {
      return true;
    }
    if (this.activeStore == Store.WorkStore) {
      if (!this.errorMsg) {
        return true;
      } else if ([StorageErrorTypes.DirectoryEmpty].includes(this.errorMsg)) {
        return true;
      } else {
        return false;
      }
    }
  }

  sortLoadData() {
    if (this.lastModifiedSort) {
      this.syncStoreItems.sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
      );
    }
    /*if (this.sizeSort) {
      this.syncStoreItems = this.syncStoreItems.sort((a, b) => 0 - (b.size.toLowerCase() > a.size.toLowerCase() ? 1 : -1));
    }*/
    if (this.fileNameSort) {
      this.syncStoreItems = this.syncStoreItems.sort(
        (a, b) => 0 - (b.name.toLowerCase() > a.name.toLowerCase() ? 1 : -1)
      );
    }
    if (this.ownerSort) {
      this.syncStoreItems = this.syncStoreItems.sort(
        (a, b) => 0 - (b.owner.toLowerCase() > a.owner.toLowerCase() ? 1 : -1)
      );
    }
    this.filterItems = JSON.parse(JSON.stringify(this.syncStoreItems));
  }

  sortByTime() {
    this.lastModifiedSort = !this.lastModifiedSort;
    this.activeSort = "time";
    //this.sizeSort = false;
    this.fileNameSort = false;
    this.ownerSort = false;
    this.filtersApplied = true;
    if (this.lastModifiedSort) {
      this.sortLoadData();
    } else {
      this.syncStoreItems.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      this.filterItems = JSON.parse(JSON.stringify(this.syncStoreItems));
    }
  }

  sortByName() {
    this.fileNameSort = !this.fileNameSort;
    this.activeSort = "name";
    //this.sizeSort = false;
    this.lastModifiedSort = false;
    this.filtersApplied = true;
    if (this.fileNameSort) {
      this.sortLoadData();
    } else {
      this.syncStoreItems = this.syncStoreItems.sort(
        (a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
      );
      this.filterItems = JSON.parse(JSON.stringify(this.syncStoreItems));
    }
  }

  sortByOwner() {
    this.ownerSort = !this.ownerSort;
    this.activeSort = "owner";
    //this.sizeSort = false;
    this.lastModifiedSort = false;
    this.fileNameSort = false;
    this.filtersApplied = true;
    if (this.ownerSort) {
      this.sortLoadData();
    } else {
      this.syncStoreItems = this.syncStoreItems.sort(
        (a, b) => 0 - (a.owner.toLowerCase() > b.owner.toLowerCase() ? 1 : -1)
      );
      this.filterItems = JSON.parse(JSON.stringify(this.syncStoreItems));
    }
  }

  openFileEditor(item?: StorageDataType) {
    let editFilePath = item?.path;
    if (item) {
      if (+item?.size > this.env.envVariables.fileEditMaxSize * 1048576) {
        this.snackBar.open(
          `File with size upto ${this.fileSize.transform(
            parseInt(this.env.envVariables.fileEditMaxSize * 1048576 + "")
          )} can only be edited`,
          "Ok",
          {
            duration: 5000,
          }
        );
        return;
      }
      if (this.cloudType == CloudTypes.MicrosoftAzure) {
        if (!item.path.includes(this.syncStorePath) && this.activeStore == Store.SyncStore) {
          editFilePath = this.syncStorePath + "/" + item.path;
        }
      }
    }
    const dialogRef = this.dialog
      .open(MonacoFileEditorComponent, {
        disableClose: true,
        autoFocus: false,
        width: "70%",
        height: "80%",
        id: "editorDialog",
        panelClass: "monaco-file-editor-dialog",
        data: {
          depName: this.depName,
          cloudType: this.cloudType,
          filePath: editFilePath,
          headNodeIp: this.fileUploadHeadNodeIP,
          routeViaSynchpc: this.routeViaSynchpc,
          isBlob: this.checkIfStorageIsBlobForAzure(),
          currentStorageName: this.currentStorageName,
          storageFactory: this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath),
        },
        hasBackdrop: false,
      })
      .afterClosed()
      .subscribe({
        next: (fileData) => {
          let process = UploadProcess.Creating;
          if (editFilePath) process = UploadProcess.Updating;
          if (fileData) {
           this.uploadFiles([fileData], process == UploadProcess.Updating ? true : false);
          }
        },
      });
  }

  editItem(file) {
    if (file.type == "file") {
      if (!this.authorizeFolderAccess(file?.path)) {
        this.spinner.hide("storageLoad");
        this.snackBar.open(
          "You do not have permission to edit this file.",
          "OK",
          { duration: 5000 }
        );
        return;
      }
    }
    this.openFileEditor(file);
  }

  authorizeFolderAccess(path: string) {
    let userName = this.authenticationService.currentUserValue.username;
    userName = userName && userName?.indexOf('@') > -1 ? userName.split('@')[0] : userName;
    // if (this.isWorkStoreActive) return true;
    if (this.currentLoggedInUserRole == UserRolesInt.JobOperator) {
      if (this.activeStore == Store.SyncStore) {
        let syncStorePath = this.syncStorePath;
        if (path == syncStorePath) {
          return true;
        }
        if (!path.includes(syncStorePath + "/")) {
          path = syncStorePath + "/" + path;
        }
        if (
          syncStorePath != path &&
          path.indexOf(`${syncStorePath}/${userName}`) < 0
        ) {
          return false;
        }
      } else if (this.activeStore == Store.WorkStore) {
        let workStorePath = this.workStorePath;
        if (path == workStorePath) {
          return true;
        }
        if (!path.includes(workStorePath + "/")) {
          path = workStorePath + "/" + path;
        }
        if (
          workStorePath != path &&
          path.indexOf(`${workStorePath}/${userName}`) < 0
        ) {
          return false;
        }
      }
    }
    return true;
  }

  convertFileSize(item: StorageDataType) {
    if (item.type != "file") {
      return "NA";
    }
    return this.fileSize.transform(parseInt(item.size));
  }

  getWebkitDirPath(path: string): string {
    if (path != "") {
      let webKitDirArr = path.split("/");
      webKitDirArr.pop();
      return webKitDirArr.join("/");
    }
  }

  manageBreadCrumbPath(path: string) {
    path = path.replace("./", "");
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (
        !path.includes(this.syncStorePath) &&
        !path.includes(this.env.envVariables.workStoreRoute)
      ) {
        path =
          (this.activeStore == Store.SyncStore
            ? this.syncStorePath
            : this.env.envVariables.workStoreRoute) +
          "/" +
          path;
      }
    }
    let pathArr = path.split("/");
    let existingPath = this.syncStoreCrumbs.map((data) => data.path);
    if (this.isFileStore) {                 
      existingPath = existingPath.map((p) => p.replace("syncstore", ""));
      this.syncStoreCrumbs = this.syncStoreCrumbs.filter(
        (d) => d.ui_name != "syncstore"
      );
    }
    if (this.syncStoreCrumbs.length + 2 > pathArr.length - 2) {
      let newBreadCrumbs: StorageDataLevel[] = [];
      for (let i = 2; i < pathArr.length; i++) {
        let currPath = path
          .split("/")
          .slice(0, i + 1)
          .join("/");
        newBreadCrumbs.push(
          new StorageDataLevel(pathArr[i], pathArr[i], currPath, "")
        );
      }
      this.syncStoreCrumbs = newBreadCrumbs;
    } else {
      for (let i = 2; i < pathArr.length; i++) {
        let currPath = path
          .split("/")
          .slice(0, i + 1)
          .join("/");
        if (!existingPath.includes(currPath)) {
          this.syncStoreCrumbs.push(
            new StorageDataLevel(pathArr[i], pathArr[i], currPath, "")
          );
        }
      }
    }
    // Safety check to prevent error
    if (this.syncStoreCrumbs.length > 0) {
      this.syncStoreCrumbs[this.syncStoreCrumbs.length - 1].className = "badge";
    }
  }

  breadCrumbPath: string = "";
  handleSearchedPath() {
    this.spinner.show("storageLoad");
    this.isBreadCrumbEditable = false;
    let isFilePath: boolean = false;
    let vmName = this.getActiveWorkstoreNodeName();

    if (vmName != "" && this.breadCrumbPath.includes(vmName)) {
      this.breadCrumbPath = this.breadCrumbPath.replace("/" + vmName, "");
    }

    let pathString = this.breadCrumbPath.trim();

    // code to remove last letter if it is "/"
    if (pathString.endsWith("/")) {
      pathString = pathString.slice(0, -1);
    }

    //check if path is empty
    if (pathString == "") {
      this.snackBar.open("Please provide path", "Ok", { duration: 3000 });
      this.breadCrumbPath = this.defaultPath;
      this.spinner.hide("storageLoad");
      return;
    }

    // check if path provided is file or folder
    let pathArr = pathString.split("/").map((p) => p.trim());
    if (pathArr.length == 1) {
      pathString =
        (this.activeStore == Store.SyncStore
          ? this.syncStorePath
          : this.env.envVariables.workStoreRoute) +
        "/" +
        pathArr[0];
      this.breadCrumbPath = this.defaultPath;
      pathArr = pathString.split("/");
    }

    if (pathString.includes(this.syncStorePath)) {
      if (this.activeStore != Store.SyncStore) {
        this.sendStoreData(Store.SyncStore);
      }
    } else if (pathString.includes(this.env.envVariables.workStoreRoute)) {
      if (this.activeStore != Store.WorkStore) {
        this.sendStoreData(Store.WorkStore);
      }
    } else {
      this.snackBar.open("Please provide valid path", "Ok", { duration: 3000 });
      this.breadCrumbPath = this.defaultPath;
      this.spinner.hide("storageLoad");
      return;
    }

    let pathArrLen = pathArr.length;
    if (pathArr[pathArrLen - 1] != "") {
      if (pathArr[pathArrLen - 1].includes(".")) {
        isFilePath = true;
      }
    }

    // if the path given contains file name then create new path till folderName
    let folderPath = pathString;
    if (isFilePath) {
      folderPath = pathArr.slice(0, pathArrLen - 1).join("/");
    }

    // create StorageDataType for path provided
    let storageTypeObj = new StorageDataType(
      isFilePath ? pathArr[pathArrLen - 2] : pathArr[pathArrLen - 1],
      "directory",
      folderPath
    );

    this.onFileFolderClick(storageTypeObj, 0);
  }

  zipMultiple(content) {
    if (this.multiSelectIndex.length == 0) {
      if (this.snackBar) this.snackBar.dismiss();
      this.snackBar.open("No file / folder selected, Unable to Zip.", "Ok", {
        duration: 5000,
      });
      return;
    }
    this.modalService
      .open(content, { ariaLabelledBy: "modal-basic-title", centered: true })
      .result.then(
        (zipName) => {
          this.zipUnzipData(this.zipFileObjects, true, zipName.split(".")[0]);
          this.multiSelectIndex = [];
        },
        (reason) => { }
      );
  }

  zipUnzipDataWrapper(content, items: StorageDataType[], toZip: boolean) {
    if (this.multiSelectIndex.length > 1 && toZip) {
      this.zipMultiple(content);
    } else {
      this.zipUnzipData(items, toZip);
    }
  }

  zipUnzipData(items: StorageDataType[], toZip: boolean, zipName: string = null) {
    let userId = this.currentLoggedInUser;
    let zipFileName: string = !zipName ? items[0].name : zipName;
    this.uniqueLogId += 1;
    let zipPath = items[0].path
      .replace(`/${items[0].name}`, "")
      .replace(items[0].name, "");
    let itemPath = items[0].path;

    if (!items[0].path.includes(this.syncStorePath) && !items[0].path.includes(this.env.envVariables.workStoreRoute)) {
      zipPath = (this.activeStore == Store.SyncStore ? this.syncStorePath : this.env.envVariables.workStoreRoute) +
        (zipPath == "" ? "" : "/" + zipPath);
      itemPath = (this.activeStore == Store.SyncStore ? this.syncStorePath : this.env.envVariables.workStoreRoute) +
        (itemPath == "" ? "" : "/" + itemPath);
    }

    if (this.authenticationService.currentUserValue.role === UserRoleNames.GlobalAdmin) {
      userId = "root";
    }

    let newLogObj: StorageLogs = this.storageLogService.createLogObject(
      this.uniqueLogId,
      this.depName,
      toZip ? 4 : 5, // Use 4 for zip, 5 for unzip
      toZip ? zipFileName : items[0].name,
      this.defaultPath,
      `${toZip ? "Zipping" : "Unzipping"} ${items
        .map((i) => i.name)
        .toString()} in path ${zipPath} :`,
      "Pending",
      true // Set showLogActions to true to enable cancel button
    );

    this.addLogToStorageLogs(newLogObj);

    let nodeName = this.getActiveWorkstoreNodeName();
    let filePaths = items.map((i) => i.path).toString();

    if (this.cloudType != CloudTypes.OnPremise) {
      filePaths = items
        .map((i) => {
          if (this.activeStore == Store.SyncStore) {
            if (!i.path.includes(this.syncStorePath)) {
              return this.syncStorePath + "/" + i.path;
            }
            return i.path;
          }
          if (this.activeStore == Store.WorkStore) {
            if (!i.path.includes(this.env.envVariables.workStoreRoute)) {
              return this.env.envVariables.workStoreRoute + "/" + i.path;
            }
            return i.path;
          }
        })
        .toString();
    }

  if (toZip) {
    this.storageLogService.createOnPremiseZipRequest(newLogObj.uniqueId);
    
    this.storageService
    .zipWithService(filePaths, zipPath, zipFileName, nodeName, this.fileUploadHeadNodeIP, userId)
    .pipe(takeUntil(this.storageLogService.onPremiseZipRequests[newLogObj.uniqueId]))
    .subscribe({
      next: (event: any) => {
        if (event.type === 'progress' || event.type === 'started') {
          let percentage = event.percentage || 0;
          if( percentage.toString().length <= 3 ){
            percentage = (event.percentage || 0).toString().padStart(3, ' ') + '%';
          }
          this.storageLogService.updateStatusOfLog(
            newLogObj.uniqueId, 
            `Zipping ${percentage}`
          );
          this.storageLogService.updateStorageLogsStore();
        } else if (event.type === 'complete') {
          this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Completed");
          this.spinner.hide("storageLoad");
          setTimeout(() => this.listFiles(this.defaultPath), 1000);
          
        }
      },
      error: (err) => {
        if (err.name === 'AbortError') {
          this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Zip Cancelled");
        } else {
          this.storageLogService.updateRequestCompleteFields(newLogObj.uniqueId, "Failed");
          this.checkUtilityServiceRunning(zipFileName);
          if (err.message) this.snackBar.open(err.message, "Ok", { duration: 5000 });
        }
        this.spinner.hide("storageLoad");
      },
      complete: () => {
        delete this.storageLogService.onPremiseZipRequests[newLogObj.uniqueId];
      }
    });
  } else {
    this.storageLogService.createOnPremiseUnzipRequest(newLogObj.uniqueId)
    
    this.storageService
      .unZipWithService(
        itemPath,
        zipPath,
        nodeName,
        this.fileUploadHeadNodeIP,
        userId,
        false,
      )
      .pipe(
        takeUntil(this.storageLogService.onPremiseUnzipRequests[newLogObj.uniqueId])
      )
      .subscribe({
        next: (event: any) => {
          if (event.type === 'started' || event.type === 'progress') {
            let percentage = event.percentage || 0;
            
            if (percentage.toString().length <= 3) {
              percentage = (event.percentage || 0).toString().padStart(3, ' ') + '%';
            }
            
            this.storageLogService.updateStatusOfLog(
              newLogObj.uniqueId, 
              `Unzipping ${percentage}`
            );
            this.storageLogService.updateStorageLogsStore();
          } 
          else if (event.type === 'complete' && event.success) {
            this.storageLogService.updateRequestCompleteFields(
              newLogObj.uniqueId, 
              "Completed"
            );
            this.spinner.hide("storageLoad");
            
            setTimeout(() => {
              this.listFiles(this.defaultPath);
            }, 500);

            this.snackBar.open("Extraction completed successfully", "Ok", {
              duration: 3000,
            });
          }
        },
        error: (err) => {
          console.error("Unzip error:", err);
          this.spinner.hide("storageLoad");

          // Check if it was cancelled
          if (err.name === 'AbortError' || err.status === 499) {
            this.storageLogService.updateRequestCompleteFields(
              newLogObj.uniqueId, 
              "Unzip Cancelled"
            );
          } else if (err.message.includes('Conflict') || err.status === 409) {
            this.handleDirectoryExistsConflict(itemPath, zipPath, nodeName, newLogObj);
          } else {
            this.handleUnzipError(err, newLogObj, filePaths, zipPath);
          }
        },
        complete: () => {
          delete this.storageLogService.onPremiseUnzipRequests[newLogObj.uniqueId];
        }
      });
  }

    this.multiSelectIndex = [];
    this.selectAll = false;
  }

  // New method to start unzip job polling
  private startUnzipJobPolling(
    uniqueId: number,
    jobId: string,
    vmIp: string,
    userId: string
  ) {

    const polling = interval(5000) // Poll every 5 seconds
      .pipe(
        switchMap(() => {
          return this.storageService.getUnzipJobStatus(jobId, vmIp);
        }),
        catchError((error) => {
          if (error.status === 404) {
            // Job not found, might be completed or cancelled
            return of({
              success: false,
              status: "completed",
              message: "Job not found, assuming completed",
            });
          }
          return of({ success: false, status: "failed", error: error.message });
        }),
        takeWhile((response) => {
          // Continue polling while status is 'in_progress'
          return response.status === "in_progress";
        }, true) // Include the final emission
      )
      .subscribe({
        next: (response) => {

          if (response.status === "completed") {
            // Job completed successfully
            this.storageLogService.updateRequestCompleteFields(
              uniqueId,
              "Completed"
            );

            // Refresh file list to show extracted files
            setTimeout(() => {
              this.listFiles(this.defaultPath);
            }, 1000);

            this.snackBar.open("Extraction completed successfully", "Ok", {
              duration: 3000,
            });

          } else if (response.status === "failed") {
            // Job failed
            this.storageLogService.updateRequestCompleteFields(
              uniqueId,
              "Failed"
            );

            const errorMessage = response.error || response.message || "Extraction failed";
            this.snackBar.open(errorMessage, "Ok", {
              duration: 5000,
            });

          }
          // For 'in_progress' status, just continue polling (no action needed)
        },
        error: (err) => {
          console.error(`Unzip polling subscription error for job ${jobId}:`, err);
          this.storageLogService.updateRequestCompleteFields(
            uniqueId,
            "Failed"
          );
          this.storageLogService.removeActiveUnzipJob(uniqueId);

          this.snackBar.open("Extraction monitoring failed", "Ok", {
            duration: 5000,
          });
        },
        complete: () => {
          // Clean up the job tracking
          this.storageLogService.removeActiveUnzipJob(uniqueId);
        },
      });

    // Store the subscription in the service
    this.storageLogService.setUnzipJobPolling(uniqueId, polling);
  }

  // Helper methods for unzip handling
  private handleUnzipSuccess(logObj: any, filePaths: string, zipPath: string) {
    this.storageLogService.updateRequestCompleteFields(
      logObj.uniqueId,
      "Completed"
    );

    this.snackBar.open("Extraction completed successfully", "Ok", {
      duration: 3000,
    });

    // Refresh file list
    setTimeout(() => {
      this.listFiles(this.defaultPath);
    }, 1000);

  }

  private handleUnzipError(err: any, logObj: any, filePaths: string, zipPath: string) {
    this.storageLogService.updateRequestCompleteFields(
      logObj.uniqueId,
      "Failed"
    );

    let errorMessage = "Extraction failed";

    this.snackBar.open(errorMessage, "Ok", {
      duration: 5000,
    });

    this.utilityService
      .checkIfUtilityServiceActive(
        this.fileUploadHeadNodeIP,
        this.depName
      )
      .subscribe();

  }

  private handleDirectoryExistsConflict(
    itemPath: string,
    zipPath: string,
    nodeName: string,
    logObj: any
  ) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "400px",
      data: {
        titleMessage: "Directory Already Exists",
        bodyMessage:
          "The extraction directory already contains files. Do you want to overwrite them?",
        submitText: "Overwrite",
        cancelText: "Cancel",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // User confirmed overwrite - restart with force overwrite
        let userId = this.currentLoggedInUser;
        if (this.authenticationService.currentUserValue.role === UserRoleNames.GlobalAdmin) {
          userId = "root";
        }

        this.storageService
          .unZipWithService(
            itemPath,
            zipPath,
            nodeName,
            this.fileUploadHeadNodeIP,
            userId,
            true // Force overwrite
          )
          .subscribe({
            next: (data: any) => {

              if (data.jobId && data.status === "in_progress") {
                // Start polling for the new job
                this.storageLogService.addActiveUnzipJob(
                  logObj.uniqueId,
                  data.jobId,
                  this.fileUploadHeadNodeIP,
                  this.currentLoggedInUser
                );

                this.storageLogService.updateLogJobId(
                  logObj.uniqueId,
                  data.jobId
                );

                this.storageLogService.updateStatusOfLog(
                  logObj.uniqueId,
                  "In Progress (Overwrite)"
                );

                this.startUnzipJobPolling(
                  logObj.uniqueId,
                  data.jobId,
                  this.fileUploadHeadNodeIP,
                  this.currentLoggedInUser
                );

                this.snackBar.open("Extraction with overwrite started...", "Ok", {
                  duration: 2000,
                });
              } else {
                this.storageLogService.updateRequestCompleteFields(
                  logObj.uniqueId,
                  "Completed"
                );
                this.snackBar.open("Extraction completed with overwrite", "Ok", {
                  duration: 3000,
                });

                // Refresh file list
                setTimeout(() => {
                  this.listFiles(this.defaultPath);
                }, 1000);
              }
            },
            error: (err) => {
              console.error("Forced unzip error:", err);
              this.storageLogService.updateRequestCompleteFields(
                logObj.uniqueId,
                "Failed"
              );
              this.snackBar.open("Failed to extract with overwrite", "Ok", {
                duration: 5000,
              });
            },
          });
      } else {
        // User cancelled
        this.storageLogService.updateRequestCompleteFields(
          logObj.uniqueId,
          "Cancelled"
        );
      }
    });
  }

  getActiveWorkstoreNodeName() {
    if (this.toShow) {
      // toShow indicates if user is in Jobs module or Storage Module
      if (this.activeStore == Store.WorkStore) {
        return this.workStoreNodeChoosen == "All"
          ? ""
          : this.workStoreNodeChoosen;
      }
    } else {
      if (this.jobNodeName || this.jobNodeName != "") return this.jobNodeName;
      if (
        this.activeStore == Store.SyncStore ||
        this.workStoreNodeChoosen == "All"
      )
        return "";
    }
    return "";
  }

  getVMNodeNameForViewFile() {
    const vmName = this.getActiveWorkstoreNodeName();
    return !vmName || vmName == "" ? null : vmName;
  }

  isDownloadEnabled(): boolean {
    const isEnabled = this.deploymentService.isShowWorkstoreDownloadEnabled(
      this.depName
    );
    // For SyncStore, downloads are allowed
    if (this.activeStore === Store.SyncStore) {
      this.showDownloadBtn = true;
      return true;
    }
    // For WorkStore, downloads depend on 'isEnabled' (from showWrokstoreDownload property)
    if (this.activeStore === Store.WorkStore) {
      this.showDownloadBtn = isEnabled;
      return isEnabled;
    }
    // Default case (if neither store matches)
    return false;
  }

  isUploadEnabled() {
    let isEnabled = this.deploymentService.isShowWorkstoreUploadEnabled(
      this.depName
    );
    if (
      this.activeStore == Store.SyncStore ||
      (isEnabled && this.activeStore == Store.WorkStore)
    ) {
      this.toShowUploadBtn = true;
      return true;
    }
    this.toShowUploadBtn = false;
  }

  get zipFileObjects(): StorageDataType[] {
    let filteredItems: StorageDataType[] = this.syncStoreItems.filter(
      (v) => v.name.toLowerCase().indexOf(this.storageSearch.toLowerCase()) > -1
    );
    return this.multiSelectIndex;
  }

  get zipFileNames(): string {
    let zipNames = this.multiSelectIndex?.map((v) => v.name);
    return zipNames.join(", ");
  }

  onDragEnter() {
    this.isDraggedOver++;
  }

  onDragLeave() {
    this.isDraggedOver--;
    if (this.isDraggedOver === 0) {
      // Only reset isDraggedOver to false if no draggable items are over the drop zone
      this.isDraggedOver = false;
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  checkForFolder(event: DragEvent): boolean {
    const items = event.dataTransfer?.items;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file") {
          const entry = item.webkitGetAsEntry();
          if (entry && entry.isDirectory) {
            // Entry is a directory (folder)
            return true;
          }
        }
      }
    }
    return false;
  }

  onDropFromDesktop(event: DragEvent) {
    event.preventDefault();
    const files = event.dataTransfer?.files;
    this.isDraggedOver = false;
    if (this.isSpinnerActive) {
      this.snackBar.open(
        "Please wait for storage to load before uploading files",
        "Close",
        { duration: 3000 }
      );
      return;
    }
    const hasFolder = this.checkForFolder(event);
    if (hasFolder) {
      this.snackBar.open("Folder upload is not supported", "Close", {
        duration: 3000,
      });
      this.isDraggedOver = false;
      return;
    }
    this.startNg2Upload(files);
  }

  updateBreadCrumb() {
    if (this.tempActiveProperty == "Jobs") {
      if (
        this.activeStore == Store.WorkStore &&
        this.deploymentService.isLocalStoreEnabled(this.depName)
      ) {
        let activeJob = this.jobService.activeJob;
        if (
          activeJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE &&
          activeJob.status != "Queued"
        ) {
          let vmName = this.getActiveWorkstoreNodeName();
          if (vmName != "") {
            let newPath = this.breadCrumbPath.split("/");
            newPath.splice(2, 0, vmName);
            this.breadCrumbPath = newPath.join("/");
          }
        }
      }
    }
  }

  copyDownloadURL() {
    if (this.multiSelectIndex.length == 0) {
      this.snackBar.dismiss();
      this.snackBar.open("No file / folder selected, Unable to Download.", "Ok", { duration: 3000 });
      return;
    }

    let clickedItem = this.multiSelectIndex[0];

    if (clickedItem.type != "file") {
      this.snackBar.open("Unable to copy download URL for directory", "Ok", { duration: 3000 });
      return;
    }

    this.spinner.show("storageLoad");

    const context: FileOperationContext = {
      deploymentName: this.depName,
      nodeName: this.getActiveWorkstoreNodeName() || undefined,
      currentPath: this.defaultPath,
      cloudType: this.cloudType,
      activeStore: this.activeStore,
      currentStorageName: this.currentStorageName,
      fileName: clickedItem.name,
      userInfo: { 
        username: this.currentLoggedInUser, 
        role: this.currentLoggedInUserRole 
      }
    };

    this.storageStrategy = this.storageFactory.getStrategy(this.cloudType, this.depName, this.activeStore, this.defaultPath);
    
    this.storageStrategy.generateDownloadUrl(clickedItem.path, context)
      .subscribe({
        next: (url: string) => {
          this.clipboard.copy(url);
          this.spinner.hide("storageLoad");
          this.snackBar.open("Download URL copied to clipboard", "Ok", { duration: 3000 });
        },
        error: (error) => {
          console.error('Failed to generate download URL:', error);
          this.spinner.hide("storageLoad");
          this.snackBar.open("Failed to generate download URL", "Ok", { duration: 3000 });
        }
      });
  }

  toggleLogs() {
    this.toShowLogs = !this.toShowLogs;
    if (this.toBlink) this.toBlink = false;
  }

  addLogToStorageLogs(log: StorageLogs) {
    this.StorageLogsData.push(log);
    this.storageLogService.addLogToStorageLogStore(log);
    if (!this.toShowLogs) this.toBlink = true;
  }

  checkIfStorageIsBlobForAzure() {
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (this.activeStore == Store.SyncStore) {
        let deployment = this.deploymentService.getProfileInfoFromSubject(this.depName);
        if (deployment.storageType == AzureStorageType.TxtBlobStorage) {
          return true;
        }
      }
    }
    return false;
  }

  isCtrlPressed: boolean = false;
  lastSelectedIndex: number = -1;
  // Event listener for keydown event to detect when Ctrl key is pressed
  @HostListener("window:keydown", ["$event"])
  handleKeyDown(event: KeyboardEvent) {
    if (event.shiftKey) {
      this.isCtrlPressed = true;
    }
  }

  // Event listener for keyup event to detect when Ctrl key is released
  @HostListener("window:keyup", ["$event"])
  handleKeyUp(event: KeyboardEvent) {
    if (!event.shiftKey) {
      this.isCtrlPressed = false;
    }
  }

  // Function to handle checkbox selection
  handleCheckboxSelection(index: number) {
    if (this.isCtrlPressed && this.lastSelectedIndex !== -1) {
      // Determine the range of rows to select
      const startElm = this.multiSelectIndex[this.multiSelectIndex.length - 2];
      const endElm = this.multiSelectIndex[this.multiSelectIndex.length - 1];

      let filteredItems: StorageDataType[] = this.syncStoreItems.filter(
        (v) =>
          v.name.toLowerCase().indexOf(this.storageSearch?.toLowerCase()) > -1
      );

      const startIdx =
        filteredItems.findIndex((elm) => elm.name === startElm.name) || -1;
      const endIdx =
        filteredItems.findIndex((elm) => elm.name === endElm.name) || -1;

      if (startIdx == -1 || endIdx == -1) return;

      // Select rows between start and end indices
      for (
        let i = Math.min(startIdx, endIdx) + 1;
        i < Math.max(startIdx, endIdx);
        i++
      ) {
        // Select or deselect rows based on your implementation
        // For example, you can toggle a selected state
        this.multiSelectIndex.push(filteredItems[i]);
      }
    }

    // Update last selected index
    this.lastSelectedIndex = index;
  }

  refreshComponent() {
    let url = this._router.url;
    this._router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this._router.navigate([decodeURI(url)]);
    });
  }

  onTabChange(event) { }

  removeTab(tab: FileTab) {
    let index = this.tabsAvailable.indexOf(tab);
    this.tabsAvailable.splice(index, 1);
    this.storageService.markAsClosed(tab.filePath);
  }

  checkIfExistsInSelectedItems(item: StorageDataType): boolean {
    return this.multiSelectIndex.some((i) => i.name === item.name);
  }

  handleStorePathForAzure<T>(data: T[]): T[] {
    if (this.cloudType == CloudTypes.OnPremise) {
      return data;
    }
    return data.map((item) => {
      if (typeof item === "string") {
        const itemPath = item as string;
        if (
          !itemPath.includes(this.syncStorePath) &&
          !itemPath.includes(this.env.envVariables.workStoreRoute)
        ) {
          if (this.activeStore === Store.SyncStore) {
            return `${this.syncStorePath}/${itemPath}` as unknown as T;
          } else {
            return `${this.env.envVariables.workStoreRoute}/${itemPath}` as unknown as T;
          }
        }
        return item;
      }
      return item;
    });
  }

  //#region context menu functions
  public toDisableOpen(item: any): boolean {
    return item.type == "file";
  }

  public isMenuItemFile(item: any): boolean {
    if (item.type !== "file") return false;
    return true;
  }

  public toshowViewFile(item: any): boolean {
    if (item.type !== "file") return false;
    
    const fileName = item.name.toLowerCase();
    
    const nonViewableExtensions = [
      '.zip', '.rar', '.7z', '.tar', '.gz', '.bz2',  // Archives
      '.exe', '.msi', '.dmg', '.deb', '.rpm',        // Executables
      '.dll', '.so', '.dylib',                       // Libraries
      '.bin', '.iso', '.img'                         // Binary files
    ];
    
    return !nonViewableExtensions.some(ext => fileName.endsWith(ext));
  }

  public toDisableEditRightClick(item: any): boolean {
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (this.checkIfStorageIsBlobForAzure()) {
        return false;
      }
    }
    if (item.type === 'file' && FileTypes.checkIfText(item.name, this.env.envVariables.TextFileExtension)) return false;
    return true;
  }

  public toShowMultipleZip(): boolean{
    if(this.cloudType == CloudTypes.OnPremise || this.defaultPath.includes(this.env.envVariables.workStoreRoute)){
      return true;
    }
    return false;
  }

  public toShowZip(item: any): boolean {

    if(this.cloudType == CloudTypes.OnPremise || this.defaultPath.includes(this.env.envVariables.workStoreRoute)){
      if(item.type == "file" && item.name.split(".").pop().toLowerCase() == "zip"){
        return false;
      }
      return true;
    }
    return false;

    // if (this.cloudType == CloudTypes.MicrosoftAzure) {
    //   if (this.checkIfStorageIsBlobForAzure()) {
    //     return false;
    //   }
    // }

    // return true;
  }

  public toShowUnZip(item: any): boolean {

    if(this.cloudType == CloudTypes.OnPremise || this.defaultPath.includes(this.env.envVariables.workStoreRoute)){
      if (item.type == "file" && item.name.split(".").pop().toLowerCase() == "zip") {
        return true;
      }
      return false;
    }

    return false;
    
    // if (this.cloudType == CloudTypes.MicrosoftAzure) {
    //   if (this.checkIfStorageIsBlobForAzure()) {
    //     return false;
    //   }
    // }
    // let extensions = ["zip"];
    // let itemNames = item.name.split(".");

    // if (extensions.includes(itemNames[itemNames.length - 1])) {
    //   return true;
    // }
    // return false;
  }

  toDisableDownloadRightClick(item): boolean {
    // Always disable for folders
    if (!this.isMenuItemFile(item)) {
      return true;
    }
    // For files, check store-level permissions via isDownloadEnabled()
    return !this.isDownloadEnabled();
  }

  public toDisableCopyDownloadUrlRightClick(item: any): boolean {
    if (this.cloudType == CloudTypes.OnPremise || this.cloudType == CloudTypes.MicrosoftAzure) {
      if (!this.checkIfStorageIsBlobForAzure()) {
        return true;
      }
    }
    if (!this.isMenuItemFile(item)) return true;
    return !this.showDownloadBtn;
  }

  toDisableCopyRightClick() {
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (this.checkIfStorageIsBlobForAzure()) {
        return true;
      }
    }

    if (this.activeStore == Store.SyncStore) return false;
    if (
      this.activeStore == Store.WorkStore &&
      this.getActiveWorkstoreNodeName() == ""
    ) {
      return false;
    }
    return true;
  }

  toDisablePasteRightClick() {
    return (
      this.copiedFilePath == undefined ||
      this.copiedFilePath == this.defaultPath ||
      this.syncStoreItems[this.lastClickedIdx]?.type == "file"
    );
  }

  toDisableRename() {
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (this.checkIfStorageIsBlobForAzure()) {
        return false;
      }
    }
    if (this.renameSupportedCloudTypes.includes(this.cloudType)) {
      return false;
    }
    return true;
  }
  //#endregion

  isStatusRed(status) {
    const predefined = ["Failed", "Pending", "Cancelled"];
    return predefined.includes(status);
  }

  checkUtilityServiceRunning(fileName = "") {
    this.storageService
      .checkIfUtilityServiceIsRunning(this.depName, this.currentLoggedInUser)
      .subscribe({
        next: (data: string) => {
          if (data.includes("Running")) {
            this._http
              .get(
                `${this.env.envVariables.httpProtocol}${this.fileUploadHeadNodeIP}:${this.fileUploadHeadNodePORT}/authorize`,
                { responseType: "text" }
              )
              .subscribe({
                next: (data) => { },
                error: (err) => {
                  console.error(err);
                  let newLogObj2: StorageLogs =
                    this.storageLogService.createLogObject(
                      this.uniqueLogId,
                      this.depName,
                      1,
                      fileName,
                      this.defaultPath,
                      `It seems there is issue with upload/download. Please visit 'Properties' in 'Storage' section for more details OR you can directly authorize by entering following URL in current browser: `,
                      "",
                      false
                    );
                  this.addLogToStorageLogs(newLogObj2);
                  this.storageLogService.updateIsRequestComplete(
                    this.uniqueLogId,
                    true
                  );
                  this.storageLogService.updateRequestCompleteFields(
                    this.uniqueLogId,
                    `${this.env.envVariables.httpProtocol}${this.fileUploadHeadNodeIP}:${this.fileUploadHeadNodePORT}/authorize`
                  );
                },
              });
          } else {
            this.snackBar.open(
              "Utility Service is Down, Please contact administrator.",
              "Ok",
              { duration: 5000 }
            );
          }
        },
        error: (err) => {
          console.error(
            "There was a error while checking utilityservice : " + err
          );
          this.snackBar.open(
            "Utility Service has some issue, Please contact administrator",
            "Ok",
            { duration: 5000 }
          );
        },
      });
  }

  private startZipJobPolling(
    uniqueId: number,
    jobId: string,
    vmIp: string,
    userId: string
  ) {
    const polling = interval(3000)
      .pipe(
        switchMap(() => {
          return this.storageService.getZipJobStatus(jobId, vmIp);
        }),
        catchError((error) => {
          if (error.status === 404) {
            // Job not found, might be completed or cancelled
            return of({
              success: false,
              status: "failed",
              error: "Job not found",
            });
          }
          return of({ success: false, status: "failed", error });
        }),
        takeWhile((response) => {
          // Continue polling while status is 'in_progress'
          return response.status === "in_progress";
        }, true) // Include the final emission
      )
      .subscribe({
        next: (response) => {

          if (response.status === "completed") {
            // Job completed successfully
            this.storageLogService.updateRequestCompleteFields(
              uniqueId,
              "Completed"
            );

            // Refresh file list to show new zip file
            setTimeout(() => {
              this.listFiles(this.defaultPath);
            }, 1000);

            this.snackBar.open("Zip operation completed successfully", "Ok", {
              duration: 3000,
            });
          } else if (response.status === "failed") {
            // Job failed
            this.storageLogService.updateRequestCompleteFields(
              uniqueId,
              "Failed"
            );

            const errorMessage = response.error || "Zip operation failed";
            this.snackBar.open(errorMessage, "Ok", {
              duration: 5000,
            });
          }
          // For 'in_progress' status, just continue polling (no action needed)
        },
        error: (err) => {
          console.error(`Polling subscription error for job ${jobId}:`, err);
          this.storageLogService.updateRequestCompleteFields(
            uniqueId,
            "Failed"
          );
          this.storageLogService.removeActiveZipJob(uniqueId);
        },
        complete: () => {
          // Clean up the job tracking
          this.storageLogService.removeActiveZipJob(uniqueId);
        },
      });

    // Store the subscription in the service
    this.storageLogService.setZipJobPolling(uniqueId, polling);
  }

  onTableBodyRightClickForMultipleSelect() {
    if (this.multiSelectIndex.length <= 1) {
      this.disableButtonsForMutliselectRightClick = false;
      return false;
    }
    this.disableButtonsForMutliselectRightClick = true;
    return true;
  }

  private cancelZipJob(log: StorageLogs) {
    const jobInfo = this.storageLogService.getActiveZipJob(log.uniqueId);

    if (log.jobId && jobInfo) {
      // Cancel job on backend
      this.storageService.cancelZipJob(log.jobId, jobInfo.vmIp).subscribe({
        next: (response) => {
          this.storageLogService.updateRequestCompleteFields(
            log.uniqueId,
            "Cancelled"
          );
          this.storageLogService.removeActiveZipJob(log.uniqueId);

        },
        error: (err) => {
          console.error(`Failed to cancel job ${log.jobId}:`, err);

          if (err.status === 404) {
            this.storageLogService.updateRequestCompleteFields(
              log.uniqueId,
              "Completed"
            );
          } else {
            this.storageLogService.updateRequestCompleteFields(
              log.uniqueId,
              "Cancelled"
            );
          }
          this.storageLogService.removeActiveZipJob(log.uniqueId);
        },
      });
    } else {
      // Fallback for operations without jobId
      this.storageLogService.updateRequestCompleteFields(
        log.uniqueId,
        "Cancelled"
      );
    }
  }

  private cancelUnzipJob(log: StorageLogs) {
    const jobInfo = this.storageLogService.getActiveUnzipJob(log.uniqueId);

    if (log.jobId && jobInfo) {

      // Cancel job on backend
      this.storageService.cancelUnzipJob(log.jobId, jobInfo.vmIp).subscribe({
        next: (response) => {
          this.storageLogService.updateRequestCompleteFields(
            log.uniqueId,
            "Cancelled"
          );
          this.storageLogService.removeActiveUnzipJob(log.uniqueId);

          this.snackBar.open("Extraction cancelled successfully", "Ok", {
            duration: 3000,
          });
        },
        error: (err) => {
          console.error(`Failed to cancel unzip job ${log.jobId}:`, err);

          if (err.status === 404) {
            // Job not found, might have already completed
            this.storageLogService.updateRequestCompleteFields(
              log.uniqueId,
              "Completed"
            );
            this.snackBar.open("Extraction may have already completed", "Ok", {
              duration: 3000,
            });
          } else {
            this.storageLogService.updateRequestCompleteFields(
              log.uniqueId,
              "Cancelled"
            );
            this.snackBar.open("Extraction cancelled (with errors)", "Ok", {
              duration: 3000,
            });
          }
          this.storageLogService.removeActiveUnzipJob(log.uniqueId);
        },
      });
    } else {
      // Fallback for operations without jobId
      this.storageLogService.updateRequestCompleteFields(
        log.uniqueId,
        "Cancelled"
      );
      this.snackBar.open("Extraction cancelled", "Ok", {
        duration: 3000,
      });
    }
  }

  applySearchFilter() {
    this.jobOrStorageTypeChanged = true;
    this.filterSearch.updateValueAndValidity();
  }

}
